'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var codeyUtilsVue2 = require('@xerius/codey-utils-vue2');
var textMaskCore = require('text-mask-core');
var vueUuid = require('vue-uuid');
var punycode = require('punycode/punycode');
var Vue = require('vue');
var frTranslations = require('filepond/locale/fr-fr');
var vueFilePond = require('vue-filepond');
var FilePondPluginFileValidateType = require('filepond-plugin-file-validate-type');
var FilePondPluginImagePreview = require('filepond-plugin-image-preview');
var FilePondPluginFileEncode = require('filepond-plugin-file-encode');
var FilePondPluginFileValidateSize = require('filepond-plugin-file-validate-size');
require('filepond/dist/filepond.min.css');
var lodashEs = require('lodash-es');
var VueSlider = require('vue-slider-component');
var popperLite_js = require('@popperjs/core/lib/popper-lite.js');
var flip = require('@popperjs/core/lib/modifiers/flip.js');
var offset = require('@popperjs/core/lib/modifiers/offset.js');
var vueChartjs = require('vue-chartjs');
var VCalendar = require('v-calendar');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var punycode__default = /*#__PURE__*/_interopDefaultLegacy(punycode);
var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);
var frTranslations__default = /*#__PURE__*/_interopDefaultLegacy(frTranslations);
var vueFilePond__default = /*#__PURE__*/_interopDefaultLegacy(vueFilePond);
var FilePondPluginFileValidateType__default = /*#__PURE__*/_interopDefaultLegacy(FilePondPluginFileValidateType);
var FilePondPluginImagePreview__default = /*#__PURE__*/_interopDefaultLegacy(FilePondPluginImagePreview);
var FilePondPluginFileEncode__default = /*#__PURE__*/_interopDefaultLegacy(FilePondPluginFileEncode);
var FilePondPluginFileValidateSize__default = /*#__PURE__*/_interopDefaultLegacy(FilePondPluginFileValidateSize);
var VueSlider__default = /*#__PURE__*/_interopDefaultLegacy(VueSlider);
var flip__default = /*#__PURE__*/_interopDefaultLegacy(flip);
var offset__default = /*#__PURE__*/_interopDefaultLegacy(offset);
var VCalendar__default = /*#__PURE__*/_interopDefaultLegacy(VCalendar);

//
//
//
//
//
//
//
//
//
//

const fallbackIcon = {
  path: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="error">
        <g id="error_2">
          <path id="error_3" fill-rule="evenodd" clip-rule="evenodd" d="M17.6496 17.664C18.9604 16.3566 19.7771 14.6351 19.9606 12.793C20.1441 10.9508 19.683 9.10199 18.6559 7.56173C17.6289 6.02147 16.0994 4.88509 14.3283 4.3463C12.5571 3.80751 10.6539 3.89967 8.94312 4.60707C7.23231 5.31447 5.8198 6.59331 4.94636 8.2256C4.07293 9.85789 3.79264 11.7426 4.15327 13.5584C4.51391 15.3742 5.49314 17.0088 6.92406 18.1834C8.35497 19.358 10.149 20 12.0003 20C13.0494 20.0018 14.0885 19.7964 15.058 19.3955C16.0275 18.9947 16.9082 18.4062 17.6496 17.664ZM13.0812 15.0945C13.0815 14.9525 13.0538 14.8119 12.9997 14.6808C12.9455 14.5496 12.866 14.4304 12.7656 14.33C12.6652 14.2296 12.546 14.1501 12.4148 14.0959C12.2837 14.0418 12.1431 14.0141 12.0011 14.0144C11.713 14.0133 11.4361 14.1262 11.231 14.3286C11.0258 14.531 10.9091 14.8063 10.9064 15.0945C10.9084 15.3842 11.0244 15.6615 11.2293 15.8663C11.4342 16.0712 11.7114 16.1872 12.0011 16.1892C12.2891 16.1862 12.5642 16.0695 12.7664 15.8644C12.9686 15.6593 13.0815 15.3825 13.0803 15.0945H13.0812ZM12.0003 12.9197C11.8091 12.9119 11.628 12.8324 11.4927 12.6972C11.3575 12.5619 11.278 12.3807 11.2702 12.1896L10.9056 8.93395C10.9102 8.64507 11.027 8.36932 11.2313 8.16503C11.4356 7.96073 11.7114 7.8439 12.0003 7.83924C12.2885 7.84174 12.564 7.95835 12.7664 8.16352C12.9688 8.3687 13.0817 8.64572 13.0803 8.93395L12.7304 12.1896C12.7225 12.3807 12.6431 12.5619 12.5078 12.6972C12.3726 12.8324 12.1914 12.9119 12.0003 12.9197Z" fill="#555555"/>
        </g>
      </g>
    </svg>
  `,
};

var script$J = {
  name: "XerIcon",
  props: {
    xerName: {
      type: String,
      required: true,
    },
    xerSize: {
      type: String,
      required: false,
      default: "",
    },
    xerAnimation: {
      type: String,
      required: false,
      default: "",
    },
    xerColor: {
      type: String,
      required: false,
      default: "",
    },
    dataAutomationId: {
      type: String,
      default: "icon",
      required: false,
    },
  },
  data() {
    return {
      cancelToken: null,
      icon: null,
    };
  },
  asyncComputed: {
    async icon() {
      let icon = await this.getIcon(this.xerName);
      let svg = icon.path;

      if (!icon.isColorIcon) {
        svg = this.removeAttributes(svg, ["fill"]);
        svg = this.setStyle(svg, ["fill: currentColor"]);
      }
      svg = this.removeAttributes(svg, ["width", "height", "preserveAspectRatio"]);
      svg = this.setStyle(svg, ["width: inherit", "height: inherit"]);
      svg = this.setAttribute(svg, "preserveAspectRatio", "xMidYMid meet");

      return svg;
    },
  },
  computed: {
    sizeClass() {
      return `xer-w-${this.xerSize} xer-h-${this.xerSize}`;
    },
    colorClass() {
      return `xer-text-${this.xerColor}`;
    },
    animationClass() {
      return `xer-${this.xerAnimation}`;
    },
  },
  methods: {
    async getIcon(name) {
      const fullName = "xer" + name[0].toUpperCase() + name.slice(1);
      const camelizeName = fullName.replace(/-./g, (x) => x[1].toUpperCase());
      return this.$xerIcons[camelizeName] || fallbackIcon;
    },
    removeAttributes(svg, attributes) {
      return attributes.reduce((processedSvg, attribute) => {
        const regex = new RegExp(`\\s+${attribute}="[^\\s]*"`, "igm");
        const matchedInstances = processedSvg.match(regex);
        if (!matchedInstances) {
          return processedSvg;
        }
        matchedInstances.forEach(() => {
          processedSvg = processedSvg.replace(regex, "");
        });

        return processedSvg;
      }, svg);
    },
    setAttribute(svg, attribute, value) {
      const regex = new RegExp("<svg[^>]*", "im");
      return svg.replace(regex, `$& ${attribute}="${value}"`);
    },
    setStyle(svg, parameters) {
      return parameters.reduce((processedSvg, parameter) => {
        const regexStyle = new RegExp('<svg[^>]*\\sstyle="[^"]*', "im");
        if (!regexStyle.exec(processedSvg)) {
          const regexNoStyle = new RegExp("<svg[^>]*", "im");
          return processedSvg.replace(regexNoStyle, `$& style="${parameter};"`);
        }
        return processedSvg.replace(regexStyle, `$& ${parameter};`);
      }, svg);
    },
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$J = script$J;

/* template */
var __vue_render__$I = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    _vm._g(
      {
        staticClass: "xer-icon",
        class:
          ((_obj = {}),
          (_obj[_vm.sizeClass] = _vm.xerSize),
          (_obj[_vm.colorClass] = _vm.xerColor),
          (_obj[_vm.animationClass] = _vm.xerAnimation),
          _obj),
        attrs: { "data-automation-id": _vm.dataAutomationId },
        domProps: { innerHTML: _vm._s(_vm.icon) },
      },
      _vm.$listeners
    )
  )
};
var __vue_staticRenderFns__$I = [];
__vue_render__$I._withStripped = true;

  /* style */
  const __vue_inject_styles__$J = function (inject) {
    if (!inject) return
    inject("data-v-64504ecf_0", { source: "\n.xer-icon[data-v-64504ecf]:focus-visible {\n  outline: none;\n}\n", map: {"version":3,"sources":["/home/vsts/work/1/s/packages/core/components/src/components/icon/icon.vue"],"names":[],"mappings":";AA2HA;EACA,aAAA;AACA","file":"icon.vue","sourcesContent":["<template>\n  <span\n    class=\"xer-icon\"\n    :class=\"{ [sizeClass]: xerSize, [colorClass]: xerColor, [animationClass]: xerAnimation }\"\n    :data-automation-id=\"dataAutomationId\"\n    v-on=\"$listeners\"\n    v-html=\"icon\"\n  />\n</template>\n\n<script>\nconst fallbackIcon = {\n  path: `\n    <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g id=\"error\">\n        <g id=\"error_2\">\n          <path id=\"error_3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.6496 17.664C18.9604 16.3566 19.7771 14.6351 19.9606 12.793C20.1441 10.9508 19.683 9.10199 18.6559 7.56173C17.6289 6.02147 16.0994 4.88509 14.3283 4.3463C12.5571 3.80751 10.6539 3.89967 8.94312 4.60707C7.23231 5.31447 5.8198 6.59331 4.94636 8.2256C4.07293 9.85789 3.79264 11.7426 4.15327 13.5584C4.51391 15.3742 5.49314 17.0088 6.92406 18.1834C8.35497 19.358 10.149 20 12.0003 20C13.0494 20.0018 14.0885 19.7964 15.058 19.3955C16.0275 18.9947 16.9082 18.4062 17.6496 17.664ZM13.0812 15.0945C13.0815 14.9525 13.0538 14.8119 12.9997 14.6808C12.9455 14.5496 12.866 14.4304 12.7656 14.33C12.6652 14.2296 12.546 14.1501 12.4148 14.0959C12.2837 14.0418 12.1431 14.0141 12.0011 14.0144C11.713 14.0133 11.4361 14.1262 11.231 14.3286C11.0258 14.531 10.9091 14.8063 10.9064 15.0945C10.9084 15.3842 11.0244 15.6615 11.2293 15.8663C11.4342 16.0712 11.7114 16.1872 12.0011 16.1892C12.2891 16.1862 12.5642 16.0695 12.7664 15.8644C12.9686 15.6593 13.0815 15.3825 13.0803 15.0945H13.0812ZM12.0003 12.9197C11.8091 12.9119 11.628 12.8324 11.4927 12.6972C11.3575 12.5619 11.278 12.3807 11.2702 12.1896L10.9056 8.93395C10.9102 8.64507 11.027 8.36932 11.2313 8.16503C11.4356 7.96073 11.7114 7.8439 12.0003 7.83924C12.2885 7.84174 12.564 7.95835 12.7664 8.16352C12.9688 8.3687 13.0817 8.64572 13.0803 8.93395L12.7304 12.1896C12.7225 12.3807 12.6431 12.5619 12.5078 12.6972C12.3726 12.8324 12.1914 12.9119 12.0003 12.9197Z\" fill=\"#555555\"/>\n        </g>\n      </g>\n    </svg>\n  `,\n};\n\nexport default {\n  name: \"XerIcon\",\n  props: {\n    xerName: {\n      type: String,\n      required: true,\n    },\n    xerSize: {\n      type: String,\n      required: false,\n      default: \"\",\n    },\n    xerAnimation: {\n      type: String,\n      required: false,\n      default: \"\",\n    },\n    xerColor: {\n      type: String,\n      required: false,\n      default: \"\",\n    },\n    dataAutomationId: {\n      type: String,\n      default: \"icon\",\n      required: false,\n    },\n  },\n  data() {\n    return {\n      cancelToken: null,\n      icon: null,\n    };\n  },\n  asyncComputed: {\n    async icon() {\n      let icon = await this.getIcon(this.xerName);\n      let svg = icon.path;\n\n      if (!icon.isColorIcon) {\n        svg = this.removeAttributes(svg, [\"fill\"]);\n        svg = this.setStyle(svg, [\"fill: currentColor\"]);\n      }\n      svg = this.removeAttributes(svg, [\"width\", \"height\", \"preserveAspectRatio\"]);\n      svg = this.setStyle(svg, [\"width: inherit\", \"height: inherit\"]);\n      svg = this.setAttribute(svg, \"preserveAspectRatio\", \"xMidYMid meet\");\n\n      return svg;\n    },\n  },\n  computed: {\n    sizeClass() {\n      return `xer-w-${this.xerSize} xer-h-${this.xerSize}`;\n    },\n    colorClass() {\n      return `xer-text-${this.xerColor}`;\n    },\n    animationClass() {\n      return `xer-${this.xerAnimation}`;\n    },\n  },\n  methods: {\n    async getIcon(name) {\n      const fullName = \"xer\" + name[0].toUpperCase() + name.slice(1);\n      const camelizeName = fullName.replace(/-./g, (x) => x[1].toUpperCase());\n      return this.$xerIcons[camelizeName] || fallbackIcon;\n    },\n    removeAttributes(svg, attributes) {\n      return attributes.reduce((processedSvg, attribute) => {\n        const regex = new RegExp(`\\\\s+${attribute}=\"[^\\\\s]*\"`, \"igm\");\n        const matchedInstances = processedSvg.match(regex);\n        if (!matchedInstances) {\n          return processedSvg;\n        }\n        matchedInstances.forEach(() => {\n          processedSvg = processedSvg.replace(regex, \"\");\n        });\n\n        return processedSvg;\n      }, svg);\n    },\n    setAttribute(svg, attribute, value) {\n      const regex = new RegExp(\"<svg[^>]*\", \"im\");\n      return svg.replace(regex, `$& ${attribute}=\"${value}\"`);\n    },\n    setStyle(svg, parameters) {\n      return parameters.reduce((processedSvg, parameter) => {\n        const regexStyle = new RegExp('<svg[^>]*\\\\sstyle=\"[^\"]*', \"im\");\n        if (!regexStyle.exec(processedSvg)) {\n          const regexNoStyle = new RegExp(\"<svg[^>]*\", \"im\");\n          return processedSvg.replace(regexNoStyle, `$& style=\"${parameter};\"`);\n        }\n        return processedSvg.replace(regexStyle, `$& ${parameter};`);\n      }, svg);\n    },\n  },\n};\n</script>\n\n<style scoped>\n.xer-icon:focus-visible {\n  outline: none;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$J = "data-v-64504ecf";
  /* module identifier */
  const __vue_module_identifier__$J = undefined;
  /* functional template */
  const __vue_is_functional_template__$J = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$J = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$I, staticRenderFns: __vue_staticRenderFns__$I },
    __vue_inject_styles__$J,
    __vue_script__$J,
    __vue_scope_id__$J,
    __vue_is_functional_template__$J,
    __vue_module_identifier__$J,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$I = {
  name: "XerLink",
  props: {
    xerIconOnly: {
      type: Boolean,
      default: false,
    },
    xerCustomStyle: {
      type: Boolean,
      default: false,
    },
    xerType: {
      type: String,
      default: "router-link",
      required: false,
    },
    href: {
      type: String,
      required: false,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataAutomationId: {
      type: String,
      default: "link",
      required: false,
    },
  },
  computed: {
    link: function () {
      return this.disabled ? null : this.href;
    },
    useRouterLink: function () {
      const regexAbsolute = new RegExp("^(//|[a-z]+:)", "i");

      if (!this.$router || !this.link || regexAbsolute.test(this.link)) {
        return false;
      }

      return true;
    },
  },
};

/* script */
const __vue_script__$I = script$I;

/* template */
var __vue_render__$H = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.useRouterLink
    ? _c(
        "a",
        {
          class: {
            "xer-link": !_vm.xerCustomStyle,
            "xer-link--icon": !_vm.xerCustomStyle && _vm.xerIconOnly,
          },
          attrs: {
            href: _vm.link,
            disabled: _vm.disabled,
            "data-automation-id": _vm.dataAutomationId,
          },
        },
        [_vm._t("default")],
        2
      )
    : _c(
        _vm.xerType,
        {
          tag: "component",
          class: {
            "xer-link": !_vm.xerCustomStyle,
            "xer-link--icon": !_vm.xerCustomStyle && _vm.xerIconOnly,
          },
          attrs: {
            to: _vm.link,
            disabled: _vm.disabled,
            "data-automation-id": _vm.dataAutomationId,
          },
        },
        [_vm._t("default")],
        2
      )
};
var __vue_staticRenderFns__$H = [];
__vue_render__$H._withStripped = true;

  /* style */
  const __vue_inject_styles__$I = undefined;
  /* scoped */
  const __vue_scope_id__$I = undefined;
  /* module identifier */
  const __vue_module_identifier__$I = undefined;
  /* functional template */
  const __vue_is_functional_template__$I = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$I = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$H, staticRenderFns: __vue_staticRenderFns__$H },
    __vue_inject_styles__$I,
    __vue_script__$I,
    __vue_scope_id__$I,
    __vue_is_functional_template__$I,
    __vue_module_identifier__$I,
    false,
    undefined,
    undefined,
    undefined
  );

//

const buttonTypes = ["cta", "danger", "no-styling"];

var script$H = {
  name: "XerButton",
  components: {
    XerLink: __vue_component__$I,
    XerIcon: __vue_component__$J,
  },
  props: {
    /** The button type */
    // eslint-disable-next-line vue/require-default-prop
    xerType: {
      type: String,
      required: false,
      validator: (val) => buttonTypes.includes(val),
    },
    /** The name of the icon */
    xerIcon: {
      type: String,
      required: false,
      default: "",
    },
    /**
     * Icon only: button will point to the left.
     * Icon + text: icon will be placed on the left side of the button.
     */
    xerLeft: {
      type: Boolean,
      default: false,
    },
    /** Shows loading icon with animation. */
    xerLoading: {
      type: Boolean,
      default: false,
    },
    /** URL of the link, which it will navigate to after click. When the link is a relative url, Vue Router (when available) will be used for navigation. */
    xerLink: {
      type: String,
      required: false,
      default: "",
    },
    /** HTML to show in the button. To be used instead of the v-html directive. */
    xerHtml: {
      type: null,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataAutomationId: {
      type: String,
      default: "button",
      required: false,
    },
  },
  data() {
    return {
      loading: {
        icon: "spinner",
        animation: "spin",
      },
    };
  },
  computed: {
    showIcon: function () {
      return this.xerIcon || this.xerLoading;
    },
    iconName: function () {
      return this.xerLoading ? this.loading.icon : this.xerIcon;
    },
    iconAnimation: function () {
      return this.xerLoading ? this.loading.animation : undefined;
    },
    typeClass: function () {
      return this.xerType ? `xer-btn--${this.xerType}` : "";
    },
    buttonIconClass: function () {
      if (this.showIcon && (this.$slots.default || this.xerHtml)) {
        return this.xerLeft ? "xer-btn--icon-left" : "xer-btn--icon";
      }

      if (this.showIcon) {
        return this.xerLeft ? "xer-btn--icon-only-reverse" : "xer-btn--icon-only";
      }

      return "";
    },
  },
};

/* script */
const __vue_script__$H = script$H;

/* template */
var __vue_render__$G = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.xerLink
    ? _c(
        "button",
        _vm._g(
          {
            ref: "button",
            class: "xer-btn " + _vm.typeClass + " " + _vm.buttonIconClass,
            attrs: {
              "data-automation-id": _vm.dataAutomationId,
              disabled: _vm.disabled,
            },
          },
          _vm.$listeners
        ),
        [
          _vm.xerHtml
            ? _c("span", { domProps: { innerHTML: _vm._s(_vm.xerHtml) } })
            : _vm._t("default"),
          _vm._v(" "),
          _vm.showIcon
            ? _c("xer-icon", {
                staticClass: "xer-btn__icon",
                attrs: {
                  "xer-name": _vm.iconName,
                  "xer-animation": _vm.iconAnimation,
                },
              })
            : _vm._e(),
        ],
        2
      )
    : _c(
        "xer-link",
        _vm._g(
          {
            class: "xer-btn " + _vm.typeClass + " " + _vm.buttonIconClass,
            attrs: {
              href: _vm.xerLink,
              disabled: _vm.disabled,
              "xer-custom-style": "",
            },
          },
          _vm.$listeners
        ),
        [
          _vm.xerHtml
            ? _c("span", { domProps: { innerHTML: _vm._s(_vm.xerHtml) } })
            : _vm._t("default"),
          _vm._v(" "),
          _vm.showIcon
            ? _c("xer-icon", {
                staticClass: "xer-btn__icon",
                attrs: {
                  "xer-name": _vm.iconName,
                  "xer-animation": _vm.iconAnimation,
                },
              })
            : _vm._e(),
        ],
        2
      )
};
var __vue_staticRenderFns__$G = [];
__vue_render__$G._withStripped = true;

  /* style */
  const __vue_inject_styles__$H = undefined;
  /* scoped */
  const __vue_scope_id__$H = undefined;
  /* module identifier */
  const __vue_module_identifier__$H = undefined;
  /* functional template */
  const __vue_is_functional_template__$H = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$H = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$G, staticRenderFns: __vue_staticRenderFns__$G },
    __vue_inject_styles__$H,
    __vue_script__$H,
    __vue_scope_id__$H,
    __vue_is_functional_template__$H,
    __vue_module_identifier__$H,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$G = {
  name: "XerStepIndicator",
  props: {
    xerTotal: {
      type: Number,
      default: 0,
    },
    xerCurrent: {
      type: Number,
      required: false,
      default: 0,
    },
    xerType: {
      type: String,
      default: "",
    },
    xerCompleted: {
      type: Boolean,
      default: false,
    },
    xerSteps: {
      type: Array,
      default: () => [],
    },
    dataAutomationId: {
      type: String,
      default: "step_indicator",
      required: false,
    },
  },
  methods: {
    getTypeClass: function () {
      if (this.xerType) {
        return `xer-step-indicator__step--${this.xerType}`;
      }
    },
    stepDone: function (step) {
      if (this.xerCompleted) {
        return true;
      }
      if (typeof step === "number") {
        return step < this.xerCurrent;
      }
      if (typeof step === "object") {
        return step.state;
      }
      return step;
    },
    stepActive: function (index) {
      if (this.xerCompleted) {
        return false;
      }
      return index === this.xerCurrent - 1;
    },
    getDataAutomationId: function (name, index) {
      if (name) {
        return `${this.dataAutomationId}_step_${name}`;
      }
      return `${this.dataAutomationId}_step_${index}`;
    },
    emitClick(step) {
      this.$emit("xer-click-step", step);
    },
  },
};

/* script */
const __vue_script__$G = script$G;

/* template */
var __vue_render__$F = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "xer-step-indicator" },
    _vm._l(
      _vm.xerSteps.length > 0 ? _vm.xerSteps : _vm.xerTotal,
      function (step, i) {
        return _c("div", {
          key: i,
          staticClass: "xer-step-indicator__step",
          class: [
            {
              "xer-step-indicator__step--done": _vm.stepDone(step),
              "xer-step-indicator__step--active": _vm.stepActive(i),
            },
            _vm.getTypeClass(),
          ],
          attrs: {
            "data-automation-id": _vm.getDataAutomationId(step.name, i),
          },
          on: {
            click: function () {
              return _vm.emitClick(_vm.xerSteps.length > 0 ? step : i)
            },
          },
        })
      }
    ),
    0
  )
};
var __vue_staticRenderFns__$F = [];
__vue_render__$F._withStripped = true;

  /* style */
  const __vue_inject_styles__$G = undefined;
  /* scoped */
  const __vue_scope_id__$G = undefined;
  /* module identifier */
  const __vue_module_identifier__$G = undefined;
  /* functional template */
  const __vue_is_functional_template__$G = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$G = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$F, staticRenderFns: __vue_staticRenderFns__$F },
    __vue_inject_styles__$G,
    __vue_script__$G,
    __vue_scope_id__$G,
    __vue_is_functional_template__$G,
    __vue_module_identifier__$G,
    false,
    undefined,
    undefined,
    undefined
  );

var variables = {
  CODEY_CDN_URL: "https://cdn.xerius.be/vue2",
  CODEY_STORAGE_URL: "https://staccwecodey.blob.core.windows.net",
};
var variables_1 = variables.CODEY_CDN_URL;

var name = "@xerius/codey-components-vue2";
var version = "11.3.5";
var description = "Builds Codey styles and components";
var main = "./src/main.js";
var engines = {
	node: ">=12.0.0"
};
var scripts = {
	clean: "rimraf dist",
	build: "npm run build:common && npm run build:copy",
	"build:common": "rollup -c",
	"build:copy": "node ./../prepare-dist.common.js",
	test: "jest",
	"test:watch": "jest --watch"
};
var author = "Xerius";
var license = "ISC";
var peerDependencies = {
	vue: "^2.6.11"
};
var dependencies = {
	"@popperjs/core": "^2.11.5",
	"@xerius/codey-style-vue2": "^11.5.1",
	"@xerius/codey-utils-vue2": "^11.0.0",
	axios: "^0.21.1",
	"chart.js": "^2.9.4",
	filepond: "^4.30.3",
	"filepond-plugin-file-encode": "^2.1.10",
	"filepond-plugin-file-validate-size": "^2.2.6",
	"filepond-plugin-file-validate-type": "^1.2.7",
	"filepond-plugin-image-preview": "^4.6.11",
	"lodash-es": "^4.17.21",
	punycode: "^2.1.1",
	"text-mask-core": "^5.1.2",
	"v-calendar": "^2.4.1",
	"vue-async-computed": "^3.9.0",
	"vue-chartjs": "^3.5.1",
	"vue-filepond": "^6.0.2",
	"vue-slider-component": "^3.2.15",
	"vue-uuid": "^2.0.2"
};
var devDependencies = {
	"@rollup/plugin-babel": "^5.3.1",
	"@rollup/plugin-json": "^4.1.0",
	"@rollup/plugin-node-resolve": "^13.3.0",
	"@vue/test-utils": "^1.3.0",
	"babel-core": "^7.0.0-bridge.0",
	"babel-preset-minify": "^0.5.1",
	"identity-obj-proxy": "3.0.0",
	rollup: "^2.71.1",
	"rollup-plugin-commonjs": "^10.1.0",
	"rollup-plugin-vue": "^5.1.9",
	sass: "^1.51.0",
	"sass-loader": "^8.0.2",
	vue: "^2.6.11"
};
var publishConfig = {
	registry: "https://xeriusit.pkgs.visualstudio.com/_packaging/XeriusGroup/npm/registry/",
	directory: "dist"
};
var sideEffects = false;
var browserslist = [
	"> 1%",
	"last 2 versions",
	"not dead",
	"IE 11"
];
var packageJson = {
	name: name,
	version: version,
	description: description,
	main: main,
	engines: engines,
	scripts: scripts,
	author: author,
	license: license,
	peerDependencies: peerDependencies,
	dependencies: dependencies,
	devDependencies: devDependencies,
	publishConfig: publishConfig,
	sideEffects: sideEffects,
	browserslist: browserslist
};

function addScrollContainerClass() {
  const appRoot = getAppWrapperElement();
  if (appRoot) appRoot.classList.add("xer-application-content");
}

function removeScrollContainerClass() {
  const appRoot = getAppWrapperElement();
  if (appRoot) appRoot.classList.remove("xer-application-content");
}

function getAppWrapperElement() {
  const appRootSearch = document.getElementsByClassName("xer-l-application");
  if (appRootSearch && appRootSearch[0]) return appRootSearch[0];

  console.warn(
    'Unable to find element with class "xer-l-application" to apply the required scroll container class. This can lead to incorrect scroll behavior!'
  );
  return undefined;
}

//

var script$F = {
  name: "XerModal",
  components: { XerButton: __vue_component__$H, XerIcon: __vue_component__$J },
  model: {
    prop: "xerOpen",
    event: "xer-close",
  },
  props: {
    xerTitle: {
      type: String,
      required: false,
      default: "",
    },
    xerOpen: {
      type: Boolean,
      default: false,
    },
    xerSlideout: {
      type: Boolean,
      default: false,
    },
    xerPictogram: {
      type: String,
      required: false,
      default: "",
    },
    xerIcon: {
      type: String,
      required: false,
      default: "",
    },
    xerIconColor: {
      type: String,
      required: false,
      default: "",
    },
    xerClosable: {
      type: Boolean,
      default: true,
    },
    xerHtml: {
      type: null,
      required: false,
      default: null,
    },
    dataAutomationId: {
      type: String,
      default: "modal",
      required: false,
    },
  },
  data() {
    return {
      isOpen: this.xerOpen,
      showInDOM: this.xerOpen,
    };
  },
  computed: {
    pictogramUrl() {
      return `${variables_1}/style/${codeyUtilsVue2.versionHelper.getVersion(
        packageJson,
        "@xerius/codey-style-vue2"
      )}/assets/images/pictograms/${this.xerPictogram}.svg`;
    },
  },
  watch: {
    xerOpen(newValue) {
      this.isOpen = newValue;
    },
    isOpen(newValue) {
      if (newValue) {
        this.showInDOM = newValue;
        addScrollContainerClass();
        return;
      }
      setTimeout(() => {
        if (!this.isOpen) {
          this.showInDOM = newValue;
          removeScrollContainerClass();
        }
      }, 300);
    },
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    this.$el.remove();
  },
  methods: {
    close() {
      if (!this.xerClosable) {
        return;
      }

      this.isOpen = false;
      this.$emit("xer-close", false);
    },
  },
};

/* script */
const __vue_script__$F = script$F;

/* template */
var __vue_render__$E = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.showInDOM
    ? _c(
        "div",
        {
          staticClass: "xer-modal",
          class: {
            "xer-modal--closed": !_vm.isOpen,
            "xer-modal--slideout": _vm.xerSlideout,
            "xer-modal--pictogram": _vm.xerPictogram || _vm.xerIcon,
          },
          attrs: { "data-automation-id": _vm.dataAutomationId },
        },
        [
          _c("div", {
            staticClass: "xer-modal__backdrop",
            attrs: { "data-automation-id": _vm.dataAutomationId + "_backdrop" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "xer-modal__content" },
            [
              _c(
                "div",
                { staticClass: "xer-modal-header" },
                [
                  _vm.xerClosable
                    ? _c("xer-button", {
                        staticClass: "xer-modal-header__close",
                        attrs: {
                          "xer-type": "no-styling",
                          "xer-icon": "cross",
                          "aria-label": "Close.",
                          "data-automation-id": _vm.dataAutomationId + "_close",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.close()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.xerPictogram
                    ? _c("img", {
                        staticClass: "xer-modal-header__pictogram",
                        attrs: { alt: _vm.xerPictogram, src: _vm.pictogramUrl },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.xerIcon
                    ? _c("xer-icon", {
                        staticClass: "xer-modal-header__icon",
                        attrs: {
                          "xer-name": _vm.xerIcon,
                          "xer-color": _vm.xerIconColor,
                          "xer-size": "14",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.xerTitle
                    ? _c("h1", {
                        staticClass: "xer-modal-header__title",
                        attrs: {
                          "data-automation-id": _vm.dataAutomationId + "_title",
                        },
                        domProps: { innerHTML: _vm._s(_vm.xerTitle) },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.xerHtml
                ? _c("span", { domProps: { innerHTML: _vm._s(_vm.xerHtml) } })
                : _vm._t("default"),
            ],
            2
          ),
        ]
      )
    : _vm._e()
};
var __vue_staticRenderFns__$E = [];
__vue_render__$E._withStripped = true;

  /* style */
  const __vue_inject_styles__$F = undefined;
  /* scoped */
  const __vue_scope_id__$F = undefined;
  /* module identifier */
  const __vue_module_identifier__$F = undefined;
  /* functional template */
  const __vue_is_functional_template__$F = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$F = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$E, staticRenderFns: __vue_staticRenderFns__$E },
    __vue_inject_styles__$F,
    __vue_script__$F,
    __vue_scope_id__$F,
    __vue_is_functional_template__$F,
    __vue_module_identifier__$F,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//

const dividerSizes = ["small", "large"];

var script$E = {
  name: "XerDivider",
  props: {
    // eslint-disable-next-line vue/require-default-prop
    xerSize: {
      type: String,
      required: false,
      validator: (val) => dividerSizes.includes(val),
    },
  },
};

/* script */
const __vue_script__$E = script$E;

/* template */
var __vue_render__$D = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "xer-divider",
    class:
      ((_obj = {}), (_obj["xer-divider--" + _vm.xerSize] = _vm.xerSize), _obj),
  })
};
var __vue_staticRenderFns__$D = [];
__vue_render__$D._withStripped = true;

  /* style */
  const __vue_inject_styles__$E = undefined;
  /* scoped */
  const __vue_scope_id__$E = undefined;
  /* module identifier */
  const __vue_module_identifier__$E = undefined;
  /* functional template */
  const __vue_is_functional_template__$E = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$E = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$D, staticRenderFns: __vue_staticRenderFns__$D },
    __vue_inject_styles__$E,
    __vue_script__$E,
    __vue_scope_id__$E,
    __vue_is_functional_template__$E,
    __vue_module_identifier__$E,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//

var script$D = {
  name: "XerNavbar",
};

/* script */
const __vue_script__$D = script$D;

/* template */
var __vue_render__$C = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("nav", { staticClass: "xer-navbar" }, [_vm._t("default")], 2)
};
var __vue_staticRenderFns__$C = [];
__vue_render__$C._withStripped = true;

  /* style */
  const __vue_inject_styles__$D = undefined;
  /* scoped */
  const __vue_scope_id__$D = undefined;
  /* module identifier */
  const __vue_module_identifier__$D = undefined;
  /* functional template */
  const __vue_is_functional_template__$D = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$D = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$C, staticRenderFns: __vue_staticRenderFns__$C },
    __vue_inject_styles__$D,
    __vue_script__$D,
    __vue_scope_id__$D,
    __vue_is_functional_template__$D,
    __vue_module_identifier__$D,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$C = {
  name: "XerNavbarItem",
  components: { XerLink: __vue_component__$I, XerIcon: __vue_component__$J },
  props: {
    xerLink: {
      type: String,
      required: false,
      default: "",
    },
    xerIcon: {
      type: String,
      required: true,
    },
    xerAnimation: {
      type: String,
      required: false,
      default: "",
    },
    xerActive: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon: function () {
      return this.disabled && this.xerIcon.includes("-color")
        ? this.xerIcon.replace("-color", "")
        : this.xerIcon;
    },
  },
};

/* script */
const __vue_script__$C = script$C;

/* template */
var __vue_render__$B = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.xerLink
    ? _c(
        "button",
        _vm._g(
          {
            staticClass: "xer-navbar__item",
            class: { "xer-navbar__item--active": _vm.xerActive },
            attrs: { disabled: _vm.disabled },
          },
          _vm.$listeners
        ),
        [
          _c("xer-icon", {
            attrs: { "xer-name": _vm.icon, "xer-animation": _vm.xerAnimation },
          }),
        ],
        1
      )
    : _c(
        "xer-link",
        _vm._g(
          {
            staticClass: "xer-navbar__item",
            class: { "xer-navbar__item--active": _vm.xerActive },
            attrs: {
              href: _vm.xerLink,
              "xer-custom-style": "",
              disabled: _vm.disabled,
            },
          },
          _vm.$listeners
        ),
        [
          _c("xer-icon", {
            attrs: { "xer-name": _vm.icon, "xer-animation": _vm.xerAnimation },
          }),
        ],
        1
      )
};
var __vue_staticRenderFns__$B = [];
__vue_render__$B._withStripped = true;

  /* style */
  const __vue_inject_styles__$C = undefined;
  /* scoped */
  const __vue_scope_id__$C = undefined;
  /* module identifier */
  const __vue_module_identifier__$C = undefined;
  /* functional template */
  const __vue_is_functional_template__$C = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$C = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
    __vue_inject_styles__$C,
    __vue_script__$C,
    __vue_scope_id__$C,
    __vue_is_functional_template__$C,
    __vue_module_identifier__$C,
    false,
    undefined,
    undefined,
    undefined
  );

//

const VARIANT_FLAT = "flat";
const VARIANT_ELEVATED = "elevated";
const variants = [VARIANT_FLAT, VARIANT_ELEVATED];

var script$B = {
  name: "XerSideSheet",
  components: {
    XerButton: __vue_component__$H,
  },
  model: {
    prop: "xerOpen",
    event: "xer-close",
  },
  props: {
    xerOpen: {
      type: Boolean,
      default: false,
    },
    xerVariant: {
      type: String,
      default: VARIANT_FLAT,
      validator: (val) => variants.includes(val),
    },
    xerMaxWidth: {
      type: Number,
      default: 0,
    },
    dataAutomationId: {
      type: String,
      default: "side_sheet",
      required: false,
    },
  },
  data() {
    return {
      isOpen: this.xerOpen,
      showInDOM: this.xerOpen,
      VARIANT_ELEVATED,
    };
  },
  computed: {
    sideSheetMaxWidth() {
      if (this.xerMaxWidth > 0) return `${this.xerMaxWidth}rem`;
      return false;
    },
  },
  watch: {
    xerOpen(newValue) {
      this.isOpen = newValue;
    },
    isOpen(newValue) {
      if (newValue) {
        this.showInDOM = newValue;
        addScrollContainerClass();
        return;
      }
      setTimeout(() => {
        if (!this.isOpen) {
          this.showInDOM = newValue;
          removeScrollContainerClass();
        }
      }, 300);
    },
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    this.$el.remove();
  },
  methods: {
    close() {
      this.isOpen = false;
      this.$emit("xer-close", false);
    },
  },
};

/* script */
const __vue_script__$B = script$B;

/* template */
var __vue_render__$A = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.showInDOM
    ? _c(
        "div",
        {
          staticClass: "xer-side-sheet",
          class: {
            "xer-side-sheet--closed": !_vm.isOpen,
            "xer-side-sheet--elevated": _vm.xerVariant === _vm.VARIANT_ELEVATED,
          },
          attrs: { "data-automation-id": "" + _vm.dataAutomationId },
        },
        [
          _c("div", {
            staticClass: "xer-side-sheet__backdrop",
            attrs: { "data-automation-id": _vm.dataAutomationId + "_backdrop" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "xer-side-sheet__panel",
              style: { maxWidth: _vm.sideSheetMaxWidth },
            },
            [
              _c(
                "div",
                { staticClass: "xer-side-sheet__header" },
                [
                  _c("xer-button", {
                    staticClass: "xer-side-sheet__close",
                    attrs: {
                      "xer-type": "no-styling",
                      "xer-icon": "cross",
                      "aria-label": "Close.",
                      "data-automation-id": _vm.dataAutomationId + "_close",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.close()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._t("header"),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "xer-side-sheet__content" },
                [_vm._t("default")],
                2
              ),
            ]
          ),
        ]
      )
    : _vm._e()
};
var __vue_staticRenderFns__$A = [];
__vue_render__$A._withStripped = true;

  /* style */
  const __vue_inject_styles__$B = undefined;
  /* scoped */
  const __vue_scope_id__$B = undefined;
  /* module identifier */
  const __vue_module_identifier__$B = undefined;
  /* functional template */
  const __vue_is_functional_template__$B = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$B = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
    __vue_inject_styles__$B,
    __vue_script__$B,
    __vue_scope_id__$B,
    __vue_is_functional_template__$B,
    __vue_module_identifier__$B,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$A = {
  name: "XerHeaderMobile",
  components: { XerButton: __vue_component__$H, XerSideSheet: __vue_component__$B },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    handleClose() {
      this.isOpen = false;
    },
  },
};

/* script */
const __vue_script__$A = script$A;

/* template */
var __vue_render__$z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "xer-header__mobile-menu" },
    [
      _c("xer-button", {
        staticClass: "xer-header__mobile-menu-button",
        attrs: {
          "xer-icon": "hamburger-menu",
          "aria-label": "mobileMenuBurger",
        },
        on: { click: _vm.toggleMenu },
      }),
      _vm._v(" "),
      _c(
        "xer-side-sheet",
        {
          on: { "xer-close": _vm.handleClose },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v;
            },
            expression: "isOpen",
          },
        },
        [
          _c(
            "div",
            { staticClass: "xer-header-mobile" },
            [_vm._t("navigation-mobile")],
            2
          ),
        ]
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$z = [];
__vue_render__$z._withStripped = true;

  /* style */
  const __vue_inject_styles__$A = undefined;
  /* scoped */
  const __vue_scope_id__$A = undefined;
  /* module identifier */
  const __vue_module_identifier__$A = undefined;
  /* functional template */
  const __vue_is_functional_template__$A = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$A = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
    __vue_inject_styles__$A,
    __vue_script__$A,
    __vue_scope_id__$A,
    __vue_is_functional_template__$A,
    __vue_module_identifier__$A,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$z = {
  name: "XerHeader",
  components: { XerHeaderMobile: __vue_component__$A, XerLink: __vue_component__$I, XerIcon: __vue_component__$J },
  props: {
    xerSmall: {
      type: Boolean,
      default: true,
    },
    xerProductName: {
      type: String,
      required: false,
      default: "",
    },
    xerPartner: {
      type: Boolean,
      default: false,
    },
    xerPartnerLogo: {
      type: String,
      required: false,
      default: "",
    },
    xerLogoLink: {
      type: String,
      default: "https://www.xerius.be",
    },
    xerLogoAlt: {
      type: String,
      default: "Xerius.",
    },
    xerHtml: {
      type: null,
      required: false,
      default: null,
    },
    xerShowMobileMenu: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      cdnUrl:
        variables_1 +
        "/style/" +
        codeyUtilsVue2.versionHelper.getVersion(packageJson, "@xerius/codey-style-vue2"),
    };
  },
};

/* script */
const __vue_script__$z = script$z;

/* template */
var __vue_render__$y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "header",
    {
      staticClass:
        "xer-header xer-l-application__header xer-t-application-header",
      class: { "xer-header--small": _vm.xerSmall },
    },
    [
      _c(
        "div",
        { staticClass: "xer-header__container" },
        [
          _c(
            "xer-link",
            {
              staticClass: "xer-header__logo",
              attrs: {
                href: _vm.xerLogoLink,
                "xer-custom-style": "",
                "data-automation-id": "header_logo-link",
              },
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.cdnUrl + "/assets/images/xerius/logo-name.svg",
                  alt: _vm.xerLogoAlt,
                },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.xerPartner
            ? _c("div", { staticClass: "xer-header__partner-background-one" })
            : _vm._e(),
          _vm._v(" "),
          _vm.xerPartner
            ? _c("div", { staticClass: "xer-header__partner-background-two" })
            : _vm._e(),
          _vm._v(" "),
          _vm.xerPartner
            ? _c(
                "div",
                { staticClass: "xer-header__partner-name" },
                [
                  _c("span", [_vm._v("&")]),
                  _vm._v(" "),
                  _c("xer-icon", {
                    staticClass: "xer-header__partner-logo",
                    attrs: {
                      "xer-name": _vm.xerPartnerLogo,
                      "data-automation-id": "header_partner-logo",
                      "xer-size": "10",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.xerProductName
            ? _c("div", { staticClass: "xer-header__product-name" }, [
                _c("img", {
                  attrs: {
                    src: _vm.cdnUrl + "/assets/images/xerius/name.svg",
                    alt: "",
                  },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "xer-product-title",
                  attrs: { "data-automation-id": "header_product-name" },
                  domProps: { innerHTML: _vm._s(_vm.xerProductName) },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "xer-header__navigation" },
            [_vm._t("navigation")],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "xer-header__slot" },
        [
          _vm.xerHtml
            ? _c("span", { domProps: { innerHTML: _vm._s(_vm.xerHtml) } })
            : _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _vm.xerShowMobileMenu
        ? _c("xer-header-mobile", {
            attrs: { "data-automation-id": "header_mobile_menu" },
            scopedSlots: _vm._u(
              [
                {
                  key: "navigation-mobile",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "xer-header__navigation" },
                        [_vm._t("navigation")],
                        2
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$y = [];
__vue_render__$y._withStripped = true;

  /* style */
  const __vue_inject_styles__$z = undefined;
  /* scoped */
  const __vue_scope_id__$z = undefined;
  /* module identifier */
  const __vue_module_identifier__$z = undefined;
  /* functional template */
  const __vue_is_functional_template__$z = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$z = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
    __vue_inject_styles__$z,
    __vue_script__$z,
    __vue_scope_id__$z,
    __vue_is_functional_template__$z,
    __vue_module_identifier__$z,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//

var script$y = {
  name: "XerHeaderNavLink",
  inheritAttrs: true,
  props: {
    xerActive: {
      type: Boolean,
      default: false,
    },
  },
};

/* script */
const __vue_script__$y = script$y;

/* template */
var __vue_render__$x = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "a",
    {
      staticClass: "xer-header__navigation-link",
      class: [
        {
          "xer-header__navigation-link--active": _vm.xerActive,
        },
      ],
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$x = [];
__vue_render__$x._withStripped = true;

  /* style */
  const __vue_inject_styles__$y = undefined;
  /* scoped */
  const __vue_scope_id__$y = undefined;
  /* module identifier */
  const __vue_module_identifier__$y = undefined;
  /* functional template */
  const __vue_is_functional_template__$y = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$y = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
    __vue_inject_styles__$y,
    __vue_script__$y,
    __vue_scope_id__$y,
    __vue_is_functional_template__$y,
    __vue_module_identifier__$y,
    false,
    undefined,
    undefined,
    undefined
  );

var masks = {
  belgischeIban: {
    mask: [
      "B",
      "E",
      /\d/,
      /\d/,
      " ",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      " ",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      " ",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
    test: {
      input: "00000000000000",
      output: "BE00 0000 0000 0000",
    },
  },
  rijksregisternummer: {
    mask: [/\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, "-", /\d/, /\d/, /\d/, ".", /\d/, /\d/],
    test: {
      input: "00000000000",
      output: "00.00.00-000.00",
    },
  },
};

//
//
//
//
//
//
//
//
//
//
//
//

var script$x = {
  name: "XerErrorList",
  props: {
    xerErrorMessages: {
      type: [Array, String],
      default: () => [],
    },
    xerSingleError: {
      type: Boolean,
      default: false,
    },
    dataAutomationId: {
      type: String,
      default: "error_list",
      required: true,
    },
  },
  computed: {
    errorMessages() {
      let errors = this.xerErrorMessages;
      if (!Array.isArray(errors)) {
        errors = [{ show: true, text: errors }];
      }

      const filteredErrorTexts = errors.filter((e) => e.show).map((e) => e.text);

      return this.xerSingleError ? [filteredErrorTexts.shift()] : filteredErrorTexts;
    },
  },
};

/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$w = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    _vm._l(_vm.errorMessages, function (error, i) {
      return _c("p", {
        key: i,
        staticClass: "xer-error-text",
        attrs: { "data-automation-id": _vm.dataAutomationId },
        domProps: { innerHTML: _vm._s(error) },
      })
    }),
    0
  )
};
var __vue_staticRenderFns__$w = [];
__vue_render__$w._withStripped = true;

  /* style */
  const __vue_inject_styles__$x = undefined;
  /* scoped */
  const __vue_scope_id__$x = undefined;
  /* module identifier */
  const __vue_module_identifier__$x = undefined;
  /* functional template */
  const __vue_is_functional_template__$x = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$x = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
    __vue_inject_styles__$x,
    __vue_script__$x,
    __vue_scope_id__$x,
    __vue_is_functional_template__$x,
    __vue_module_identifier__$x,
    false,
    undefined,
    undefined,
    undefined
  );

//

const CUSTOM_MASK = "custom";

const inputTypes$1 = ["text", "number", "tel", "date", "password", "email"];
const maskTypes = [...Object.keys(masks), CUSTOM_MASK];

const customEventList = {
  optionClick: "xer-option-click",
  iconClick: "xer-icon-click",
};

const getDataAutomationIdList = (dataAutomationId = "textfield") => ({
  label: `${dataAutomationId}_label`,
  input: `${dataAutomationId}_input`,
  icon: `${dataAutomationId}_icon`,
  options: `${dataAutomationId}_options`,
  option: `${dataAutomationId}_option`,
  error: `${dataAutomationId}_error`,
  caption: `${dataAutomationId}_caption`,
});

var script$w = {
  name: "XerTextfield",
  components: { XerErrorList: __vue_component__$x, XerIcon: __vue_component__$J },
  inheritAttrs: false,
  props: {
    xerCounter: {
      type: Boolean,
      default: false,
    },
    xerCounterLimit: {
      type: Number,
      default: 150,
    },
    xerShowCounterExceeded: {
      type: Boolean,
      default: false,
    },
    xerType: {
      type: String,
      default: "text",
      validator: (val) => inputTypes$1.includes(val),
    },
    xerLabel: {
      type: String,
      required: false,
      default: "",
    },
    xerId: {
      type: String,
      required: false,
      default: "",
    },
    xerErrorMessage: {
      type: [Array, String],
      default: () => [],
    },
    xerSingleError: {
      type: Boolean,
      default: false,
    },
    xerError: {
      type: Boolean,
      default: false,
    },
    xerCaption: {
      type: String,
      required: false,
      default: "",
    },
    xerIcon: {
      type: String,
      required: false,
      default: "",
    },
    xerIconColor: {
      type: String,
      required: false,
      default: "",
    },
    xerIconLeft: {
      type: Boolean,
      default: false,
    },
    xerOptions: {
      type: Array,
      default: () => [],
    },
    xerShowOptions: {
      type: Boolean,
      default: false,
    },
    xerAutoShowOptions: {
      type: Boolean,
      default: false,
    },
    xerFloatOptions: {
      type: Boolean,
      default: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    xerMask: {
      type: String,
      required: false,
      validator: (val) => maskTypes.includes(val),
    },
    xerCustomMask: {
      type: [Array, Function],
      required: false,
      default: () => [],
    },
    xerDebounce: {
      type: Number,
      default: 0,
    },
    xerLoading: {
      type: Boolean,
      default: false,
    },
    xerCustomContainerClasses: {
      type: Array,
      required: false,
      default: () => [],
    },
    xerReadonly: {
      type: Boolean,
      default: false,
    },
    xerPlaceholder: {
      type: String,
      required: false,
      default: "",
    },
    value: {
      type: null,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataAutomationId: {
      type: String,
      default: "textfield",
      required: false,
    },
    xerScrollableOptions: {
      type: Boolean,
      default: false,
    },
    xerIsDatePicker: {
      type: Boolean,
      default: false,
    },
    xerDisableClearIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: this.value,
      showOptions: false,
      optionInFocus: false,
      inputInFocus: false,
      loading: {
        icon: "spinner",
        animation: "spin",
      },
      dataAutomationIdList: { ...getDataAutomationIdList(this.dataAutomationId) },
      characterCount: this.value ? this.value.length : 0,
    };
  },
  computed: {
    id() {
      return this.xerId || `xer-input-${this.xerType}_${vueUuid.uuid.v4()}`;
    },
    showIcon() {
      return this.xerIcon || this.xerLoading;
    },
    iconName() {
      if (this.xerLoading) return this.loading.icon;
      if (this.xerDisableClearIcon) return this.xerIcon;

      return this.xerLoading ? this.loading.icon : this.xerIcon;
    },
    iconAnimation() {
      return this.xerLoading ? this.loading.animation : undefined;
    },
    inputListeners() {
      const vm = this;
      return {
        ...this.$listeners,
        blur() {
          vm.inputInFocus = false;
          setTimeout(() => {
            if (!vm.optionInFocus) {
              vm.showOptions = false;
            }
          });
          vm.$emit("blur");
        },
        focus() {
          if (vm.xerAutoShowOptions) {
            vm.showOptions = true;
            vm.inputInFocus = true;
          }
          vm.$emit("focus");
        },
        input(event) {
          if (vm.xerMask) {
            vm.textMaskInputElement.update();
          }
          vm.inputValue = punycode__default["default"].toUnicode(event.target.value);
          vm.characterCount = punycode__default["default"].toUnicode(event.target.value).length;
          if (vm.timeout) clearTimeout(vm.timeout);
          if (vm.xerDebounce > 0) {
            vm.timeout = setTimeout(
              () => vm.$emit("input", punycode__default["default"].toUnicode(event.target.value)),
              vm.xerDebounce
            );
          } else {
            let eventValue = punycode__default["default"].toUnicode(event.target.value);
            if (vm.xerIsDatePicker) {
              eventValue = event;
            }
            vm.$emit("input", eventValue);
          }
          if (vm.characterCount > vm.xerCounterLimit) {
            vm.$emit("xer-character-limit");
          }
        },
      };
    },
    counterExceeded() {
      return this.characterCount > this.xerCounterLimit;
    },
    counter() {
      return this.characterCount + "/" + this.xerCounterLimit;
    },
  },
  watch: {
    value(newVal) {
      this.$nextTick(() => {
        this.inputValue = newVal;
        this.characterCount = newVal ? newVal.length : 0;
        if (this.xerMask) {
          this.textMaskInputElement.update(newVal);
        }
      });
    },
    xerMask(newVal) {
      if (!newVal) {
        return;
      }
      this.initMask(this.inputValue);
    },
  },
  mounted() {
    if (this.xerMask) {
      this.initMask(this.inputValue);
    }
  },
  methods: {
    optionFocus() {
      if (this.xerAutoShowOptions) {
        this.showOptions = true;
        this.optionInFocus = true;
      }
    },
    optionBlur() {
      this.optionInFocus = false;
      setTimeout(() => {
        if (!this.optionInFocus && !this.inputInFocus) {
          this.showOptions = false;
        }
      });
    },
    optionSelect(option) {
      this.showOptions = false;
      this.optionInFocus = false;
      this.$emit(customEventList.optionClick, option);
    },
    iconClick() {
      if (this.iconName === "cross") {
        this.inputValue = "";
        this.$emit("input", "");
      } else {
        this.showOptions = !this.showOptions;
        this.$emit(customEventList.iconClick);
        // Focus input as an Icon does not have focus or blur events.
        if (!this.xerIsDatePicker) {
          this.$refs.input.focus();
        }
      }
    },
    initMask(value) {
      this.textMaskInputElement = textMaskCore.createTextMaskInputElement({
        inputElement: this.$refs.input,
        mask: this.xerMask === CUSTOM_MASK ? this.xerCustomMask : masks[this.xerMask].mask,
        guide: false,
      });
      this.textMaskInputElement.update(value);
    },
  },
};

/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$v = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "xer-text-input",
      class: [
        {
          "xer-text-input--error":
            _vm.xerError || (_vm.xerShowCounterExceeded && _vm.counterExceeded),
          "xer-text-input--disabled": _vm.disabled,
          "xer-text-input--counter-error":
            _vm.xerShowCounterExceeded && _vm.counterExceeded,
        },
      ],
      attrs: { "data-automation-id": _vm.dataAutomationId },
    },
    [
      _c(
        "div",
        { class: { "xer-input-button": _vm.$slots.default } },
        [
          _c(
            "div",
            { class: { "xer-input-label": _vm.$slots.default } },
            [
              _vm.xerLabel
                ? _c("label", {
                    staticClass: "xer-text-input__label",
                    class: { "xer-input-label__label": _vm.$slots.default },
                    attrs: {
                      for: _vm.id,
                      "data-automation-id": _vm.dataAutomationIdList.label,
                    },
                    domProps: { innerHTML: _vm._s(_vm.xerLabel) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots.multiple
                ? _c(
                    "div",
                    { staticClass: "xer-multiple-input" },
                    [_vm._t("multiple")],
                    2
                  )
                : _vm.$slots.customInput
                ? _vm._t("customInput")
                : _c(
                    "div",
                    {
                      class: [
                        {
                          "xer-input-dropdown":
                            _vm.xerShowOptions || _vm.showOptions,
                          "xer-input-icon": _vm.showIcon,
                        },
                      ].concat(_vm.xerCustomContainerClasses),
                    },
                    [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              ref: "input",
                              staticClass: "xer-text-input__input",
                              class: [
                                {
                                  "xer-input-icon__input--icon-left":
                                    _vm.xerIconLeft,
                                  "xer-input-icon__input": _vm.showIcon,
                                },
                              ],
                              attrs: {
                                id: _vm.id,
                                type: _vm.xerType,
                                readonly: _vm.xerReadonly,
                                placeholder: _vm.xerPlaceholder,
                                disabled: _vm.disabled,
                                "data-automation-id":
                                  _vm.dataAutomationIdList.input,
                              },
                              domProps: { value: _vm.inputValue },
                            },
                            "input",
                            _vm.$attrs,
                            false
                          ),
                          _vm.inputListeners
                        )
                      ),
                      _vm._v(" "),
                      _vm.showIcon
                        ? _c("xer-icon", {
                            staticClass: "xer-input-icon__icon",
                            attrs: {
                              "xer-name": _vm.iconName,
                              "xer-animation": _vm.iconAnimation,
                              "xer-color": _vm.xerIconColor,
                              "data-automation-id":
                                _vm.dataAutomationIdList.icon,
                            },
                            on: { click: _vm.iconClick },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.xerShowOptions || _vm.showOptions
                        ? _c(
                            "div",
                            {
                              staticClass: "xer-input-dropdown__list",
                              class: {
                                "xer-input-dropdown__list--no-float":
                                  !_vm.xerFloatOptions,
                                "xer-input-dropdown__list--scrollable":
                                  _vm.xerScrollableOptions,
                              },
                              attrs: {
                                "data-automation-id":
                                  _vm.dataAutomationIdList.options,
                              },
                            },
                            [
                              _vm.xerOptions.length === 0
                                ? _vm._t("options", null, {
                                    xerOptionSelect: _vm.optionSelect,
                                    xerFocus: _vm.optionFocus,
                                    xerBlur: _vm.optionBlur,
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.xerOptions
                                ? _c(
                                    "div",
                                    _vm._l(
                                      _vm.xerOptions,
                                      function (option, index) {
                                        return _c("p", {
                                          key: index,
                                          staticClass: "xer-input-list-item",
                                          attrs: {
                                            tabindex: "0",
                                            "data-automation-id":
                                              _vm.dataAutomationIdList.option,
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(option.label),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.optionSelect(option)
                                            },
                                            keyup: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.optionSelect(option)
                                            },
                                            focus: _vm.optionFocus,
                                            blur: _vm.optionBlur,
                                          },
                                        })
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "xer-text-input-info" }, [
        _c(
          "div",
          [
            _vm.xerError
              ? _c("xer-error-list", {
                  staticClass: "xer-text-input__error",
                  attrs: {
                    "data-automation-id": _vm.dataAutomationIdList.error,
                    "xer-error-messages": _vm.xerErrorMessage,
                    "xer-single-error": _vm.xerSingleError,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.xerCaption
              ? _c("p", {
                  staticClass: "xer-caption xer-text-input__caption",
                  attrs: {
                    "data-automation-id": _vm.dataAutomationIdList.caption,
                  },
                  domProps: { innerHTML: _vm._s(_vm.xerCaption) },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.xerCounter
          ? _c("p", {
              staticClass: "xer-text-input__counter",
              attrs: { "data-automation-id": "text-input_counter" },
              domProps: { textContent: _vm._s(_vm.counter) },
            })
          : _vm._e(),
      ]),
    ]
  )
};
var __vue_staticRenderFns__$v = [];
__vue_render__$v._withStripped = true;

  /* style */
  const __vue_inject_styles__$w = undefined;
  /* scoped */
  const __vue_scope_id__$w = undefined;
  /* module identifier */
  const __vue_module_identifier__$w = undefined;
  /* functional template */
  const __vue_is_functional_template__$w = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$w = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
    __vue_inject_styles__$w,
    __vue_script__$w,
    __vue_scope_id__$w,
    __vue_is_functional_template__$w,
    __vue_module_identifier__$w,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$v = {
  name: "XerTextfieldOption",
  props: {
    xerLabel: {
      type: String,
      required: true,
    },
    xerValue: {
      type: [String, Object],
      required: true,
    },
    xerIndex: {
      type: Number,
      required: true,
    },
    xerOptionSelect: {
      type: Function,
      required: true,
    },
    xerFocus: {
      type: Function,
      required: true,
    },
    xerBlur: {
      type: Function,
      required: true,
    },
    dataAutomationId: {
      type: String,
      default: "textfield_option",
      required: false,
    },
  },
};

/* script */
const __vue_script__$v = script$v;

/* template */
var __vue_render__$u = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "p",
    {
      key: _vm.xerIndex,
      staticClass: "xer-input-list-item",
      attrs: { tabindex: "0", "data-automation-id": _vm.xerDataAutomationId },
      on: {
        click: function ($event) {
          return _vm.xerOptionSelect({
            label: _vm.xerLabel,
            value: _vm.xerValue,
          })
        },
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.xerOptionSelect({
            label: _vm.xerLabel,
            value: _vm.xerValue,
          })
        },
        focus: _vm.xerFocus,
        blur: _vm.xerBlur,
      },
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$u = [];
__vue_render__$u._withStripped = true;

  /* style */
  const __vue_inject_styles__$v = undefined;
  /* scoped */
  const __vue_scope_id__$v = undefined;
  /* module identifier */
  const __vue_module_identifier__$v = undefined;
  /* functional template */
  const __vue_is_functional_template__$v = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$v = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
    __vue_inject_styles__$v,
    __vue_script__$v,
    __vue_scope_id__$v,
    __vue_is_functional_template__$v,
    __vue_module_identifier__$v,
    false,
    undefined,
    undefined,
    undefined
  );

var XerSlotList = Vue__default["default"].component("XerSlotList", {
  props: {
    xerClass: {
      type: String,
      default: "",
    },
  },
  render: function (createElement) {
    return this.$slots.default
      ? createElement(
          "div",
          this.$slots.default.map((item) => {
            return createElement(
              "div",
              {
                attrs: { class: this.xerClass },
              },
              [item]
            );
          })
        )
      : "";
  },
});

//

const INPUT_RADIO = "radio";
const INPUT_CHECKBOX = "checkbox";

const inputTypes = [INPUT_RADIO, INPUT_CHECKBOX];

var script$u = {
  name: "XerOptionInput",
  components: {
    XerSlotList,
  },
  inheritAttrs: false,
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    xerType: {
      type: String,
      required: true,
      validator: (val) => inputTypes.includes(val),
    },
    xerLabel: {
      type: String,
      required: false,
      default: undefined,
    },
    xerId: {
      type: String,
      required: false,
      default: "",
    },
    xerContainer: {
      type: Boolean,
      default: false,
    },
    xerIntermediate: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: null,
      default: undefined,
    },
    value: {
      type: null,
      default: undefined,
    },
    dataAutomationId: {
      type: String,
      default: "option-input",
      required: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    id() {
      return this.xerId || `xer-input-${this.xerType}_${vueUuid.uuid.v4()}`;
    },
    isChecked() {
      if (this.xerType === INPUT_CHECKBOX || this.valueIsUndefined) {
        return this.checked;
      }
      return this.checked === this.value;
    },
    valueIsUndefined() {
      return typeof this.value === "undefined";
    },
    inputListeners() {
      const vm = this;
      return {
        ...this.$listeners,
        change(event) {
          if (vm.xerType === INPUT_RADIO && !vm.valueIsUndefined) {
            vm.$emit("change", event.target.value);
          } else {
            vm.$emit("change", event.target.checked);
          }
        },
      };
    },
  },
};

/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$t = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "xer-option-input",
      class: {
        "xer-option-input-container": _vm.xerContainer,
        "xer-option-input-container--disabled":
          _vm.xerContainer && _vm.disabled,
        "xer-option-input--intermediate": _vm.xerIntermediate,
      },
      attrs: { "data-automation-id": _vm.dataAutomationId },
    },
    [
      _c(
        "input",
        _vm._g(
          _vm._b(
            {
              ref: "input",
              staticClass: "xer-option-input__input",
              class: { "xer-option-input__input--read-only": _vm.readOnly },
              attrs: {
                id: _vm.id,
                type: _vm.xerType,
                disabled: _vm.disabled || _vm.readOnly,
                "data-automation-id": _vm.dataAutomationId + "_input",
              },
              domProps: { checked: _vm.isChecked, value: _vm.value },
            },
            "input",
            _vm.$attrs,
            false
          ),
          _vm.inputListeners
        )
      ),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "xer-option-input__label",
          class: {
            "xer-option-input__input--read-only": _vm.readOnly,
            "xer-option-input__no-label": !_vm.xerLabel,
          },
          attrs: {
            for: _vm.id,
            "data-automation-id": _vm.dataAutomationId + "_label",
          },
        },
        [
          !!_vm.xerLabel
            ? _c("span", { domProps: { innerHTML: _vm._s(_vm.xerLabel) } })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.$slots.default
        ? _c(
            "div",
            { staticClass: "xer-option-input__sub-content" },
            [
              _c(
                "xer-slot-list",
                { attrs: { "xer-class": "xer-option-input-sub-content" } },
                [_vm._t("default")],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$t = [];
__vue_render__$t._withStripped = true;

  /* style */
  const __vue_inject_styles__$u = undefined;
  /* scoped */
  const __vue_scope_id__$u = undefined;
  /* module identifier */
  const __vue_module_identifier__$u = undefined;
  /* functional template */
  const __vue_is_functional_template__$u = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$u = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
    __vue_inject_styles__$u,
    __vue_script__$u,
    __vue_scope_id__$u,
    __vue_is_functional_template__$u,
    __vue_module_identifier__$u,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$t = {
  name: "XerOptionInputList",
  components: {
    XerSlotList,
    XerErrorList: __vue_component__$x,
  },
  props: {
    xerQuestion: {
      type: String,
      required: false,
      default: "",
    },
    xerErrorMessage: {
      type: [Array, String],
      default: () => [],
    },
    xerSingleError: {
      type: Boolean,
      default: false,
    },
    xerError: {
      type: Boolean,
      default: false,
    },
    xerDataAutomationId: {
      type: String,
      default: "option-input-list",
    },
  },
};

/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$s = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "xer-option-input-list",
      class: { "xer-option-input-list--error": _vm.xerError },
    },
    [
      _vm.xerQuestion
        ? _c("p", {
            staticClass: "xer-option-input-list__question",
            attrs: {
              "data-automation-id": _vm.xerDataAutomationId + "_question",
            },
            domProps: { innerHTML: _vm._s(_vm.xerQuestion) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "xer-slot-list",
        { attrs: { "xer-class": "xer-option-input-list__option" } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.xerError
        ? _c("xer-error-list", {
            staticClass: "xer-option-input-list__error",
            attrs: {
              "data-automation-id": _vm.xerDataAutomationId + "_error",
              "xer-error-messages": _vm.xerErrorMessage,
              "xer-single-error": _vm.xerSingleError,
            },
          })
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$s = [];
__vue_render__$s._withStripped = true;

  /* style */
  const __vue_inject_styles__$t = undefined;
  /* scoped */
  const __vue_scope_id__$t = undefined;
  /* module identifier */
  const __vue_module_identifier__$t = undefined;
  /* functional template */
  const __vue_is_functional_template__$t = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$t = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
    __vue_inject_styles__$t,
    __vue_script__$t,
    __vue_scope_id__$t,
    __vue_is_functional_template__$t,
    __vue_module_identifier__$t,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//

var script$s = {
  name: "XerEllipsis",
  props: {
    xerContentClass: {
      type: String,
      required: false,
      default: "",
    },
    dataAutomationId: {
      type: String,
      default: "ellipsis",
      required: false,
    },
  },
  data() {
    return {
      showContent: false,
    };
  },
};

/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$r = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "xer-ellipsis",
      class: { "xer-ellipsis--show": _vm.showContent },
      attrs: { "data-automation-id": _vm.dataAutomationId },
      on: {
        click: function ($event) {
          _vm.showContent = true;
        },
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "xer-ellipsis__content",
          class:
            ((_obj = {}),
            (_obj["" + _vm.xerContentClass] = _vm.xerContentClass),
            _obj),
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$r = [];
__vue_render__$r._withStripped = true;

  /* style */
  const __vue_inject_styles__$s = undefined;
  /* scoped */
  const __vue_scope_id__$s = undefined;
  /* module identifier */
  const __vue_module_identifier__$s = undefined;
  /* functional template */
  const __vue_is_functional_template__$s = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$s = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
    __vue_inject_styles__$s,
    __vue_script__$s,
    __vue_scope_id__$s,
    __vue_is_functional_template__$s,
    __vue_module_identifier__$s,
    false,
    undefined,
    undefined,
    undefined
  );

var nlTranslations = {
  labelIdle: `Bestanden slepen en hier neerzetten of <span class="filepond--label-action">kies een bestand</span>`,
  labelInvalidField: "Veld bevat ongeldige bestanden",
  labelFileWaitingForSize: "Wachten op formaat",
  labelFileSizeNotAvailable: "Formaat niet beschikbaar",
  labelFileLoading: "Laden",
  labelFileLoadError: "Fout tijdens het laden",
  labelFileProcessing: "Uploaden",
  labelFileProcessingComplete: "Uploaden voltooid",
  labelFileProcessingAborted: "Uploaden onderbroken",
  labelFileProcessingError: "Fout tijdens het uploaden",
  labelFileProcessingRevertError: "Fout tijdens het terugzetten",
  labelFileRemoveError: "Fout tijdens het wissen",

  labelTapToCancel: "klik om te annuleren",
  labelTapToRetry: "klik om opnieuw te proberen",
  labelTapToUndo: "klik om terug te keren",

  labelButtonRemoveItem: "Verwijderen",
  labelButtonAbortItemLoad: "Annuleren",
  labelButtonRetryItemLoad: "Opnieuw",
  labelButtonAbortItemProcessing: "Annuleren",
  labelButtonUndoItemProcessing: "Vorige",
  labelButtonRetryItemProcessing: "Opnieuw",
  labelButtonProcessItem: "Opladen",

  labelMinFileSizeExceeded: "Het bestand is te klein",
  labelMinFileSize: "Het bestand moet minimum {filesize} zijn",

  labelMaxFileSizeExceeded: "Het bestand is te groot",
  labelMaxFileSize: "De toegelaten bestandsgrootte is {filesize}",
  labelMaxTotalFileSizeExceeded: "De bestanden zijn te groot",
  labelMaxTotalFileSize: "De totaal toegelaten bestandsgrootte is {filesize}",

  labelFileTypeNotAllowed: "Bestand ongeldig",
  fileValidateTypeLabelExpectedTypes: `Verwacht bestandstype: {allButLastType} of {lastType}`,

  imageValidateSizeLabelFormatError: "Afbeeldingstype wordt niet ondersteund",
  imageValidateSizeLabelImageSizeTooSmall: "De afbeelding is te klein",
  imageValidateSizeLabelImageSizeTooBig: "De afbeelding is te groot",
  imageValidateSizeLabelExpectedMinSize: `De minimale bestandsgrootte is {minWidth} × {minHeight}`,
  imageValidateSizeLabelImageResolutionTooLow: `De resolutie van de afbeelding is te laag`,
  imageValidateSizeLabelImageResolutionTooHigh: `De resolutie van de afbeelding is te hoog`,
  imageValidateSizeLabelExpectedMinResolution: `De minimale resolutie van de afbeelding moet {minResolution} zijn `,
  imageValidateSizeLabelExpectedMaxResolution: `De maximale resolutie mag niet groter zijn dan {maxResolution}`,
};

const languageFiles = {
  "nl-be": nlTranslations,
  "fr-be": {
    ...frTranslations__default["default"],
    labelMinFileSizeExceeded: "Le fichier est trop petit",
    labelMinFileSize: "Le fichier doit être au moins {filesize}",
    labelIdle: `Faites glisser ou <span class="filepond--label-action">choisissez vos fichiers</span>`,
  },
  en: {
    labelIdle: `Drag & drop your files or <span class="filepond--label-action">browse</span>`,
  },
};

function getTranslations (isoLang = "nl-be") {
  const translations = languageFiles[isoLang];
  if (!translations) {
    throw new Error(`File Upload: unsupported language ${isoLang}`);
  }
  return translations;
}

/**
 * Validation function for the extension plugin to provide an extra check on selected file extensions.
 * @param {string[]} allowedExtensions
 * @param {File} source
 * @param {string} type
 * @returns
 */
function verifyExtension (allowedExtensions, source, type) {
  return new Promise((res, rej) => {
    const lastPointIndex = source.name.lastIndexOf(".");
    const extension = source.name.substring(lastPointIndex + 1).toLowerCase();

    if (allowedExtensions.length === 0) {
      res(type);
    }

    if (allowedExtensions.map((extension) => extension.toLowerCase()).includes(extension)) {
      return res(type);
    }
    rej(new Error(`file extension "${extension}" is not allowed`));
  });
}

//

var script$r = {
  name: "XerFileUpload",
  model: {
    prop: "xerFiles",
    event: "xer-update-files",
  },
  props: {
    /** Pass filepond plugins within this property */
    xerPlugins: {
      type: Array,
      default: () => [],
    },
    /** pass an array of file extensions that are allowed */
    xerAllowedExtensions: {
      type: Array,
      default: () => [],
    },
    xerLanguage: {
      type: String,
      default: "nl-be",
    },
    /** pass an array of existing file uploads, also available as v-model */
    xerFiles: {
      type: Array,
      default: () => [],
    },
    dataAutomationId: {
      type: String,
      default: "file_upload",
      required: false,
    },
  },
  data() {
    return {
      filePond: null,
      files: [],
    };
  },
  computed: {
    listeners() {
      const vm = this;
      const events = [
        "init",
        "addfilestart",
        "addfileprogress",
        "addfile",
        "processfilestart",
        "processfileprogress",
        "processfileabort",
        "processfilerevert",
        "processfile",
        "removefile",
        "updatefiles",
      ];

      return {
        ...events
          .map((event) => ({
            [event](...args) {
              console.log("event: ", event);
              vm.$emit(event, ...args);
            },
          }))
          .reduce((prev, current) => ({ ...prev, ...current }), {}),
        ...this.$listeners,
      };
    },
    translations() {
      return getTranslations(this.xerLanguage);
    },
  },
  mounted() {
    this.filePond = vueFilePond__default["default"](
      FilePondPluginImagePreview__default["default"],
      FilePondPluginFileValidateType__default["default"],
      FilePondPluginFileEncode__default["default"],
      ...this.xerPlugins
    );
    this.files = this.xerFiles;
  },
  methods: {
    verifyExtension,
    addFile(error, file) {
      if (error) {
        this.$emit("xer-error", error);
      }

      this.files.push(file);
      this.$emit("xer-update-files", this.files);
    },
    removeFile(error, file) {
      if (error) {
        this.$emit("xer-error", error);
      }

      this.files = this.files.filter((f) => f.id !== file.id);
      this.$emit("xer-update-files", this.files);
    },
    beforeAdd(file) {
      const fileExists = this.files.some((f) => f.filename === file.filename);
      return !fileExists;
    },
  },
};

/* script */
const __vue_script__$r = script$r;

/* template */
var __vue_render__$q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.filePond,
    _vm._g(
      _vm._b(
        {
          ref: "fileUpload",
          tag: "component",
          attrs: {
            "file-validate-type-detect-type": function (source, type) {
              return _vm.verifyExtension(_vm.xerAllowedExtensions, source, type)
            },
            "before-add-file": _vm.beforeAdd,
            files: _vm.files,
            "data-automation-id": _vm.dataAutomationId,
          },
          on: { addfile: _vm.addFile, removefile: _vm.removeFile },
        },
        "component",
        [_vm.$attrs, _vm.translations],
        false
      ),
      _vm.listeners
    )
  )
};
var __vue_staticRenderFns__$q = [];
__vue_render__$q._withStripped = true;

  /* style */
  const __vue_inject_styles__$r = undefined;
  /* scoped */
  const __vue_scope_id__$r = undefined;
  /* module identifier */
  const __vue_module_identifier__$r = undefined;
  /* functional template */
  const __vue_is_functional_template__$r = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$r = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
    __vue_inject_styles__$r,
    __vue_script__$r,
    __vue_scope_id__$r,
    __vue_is_functional_template__$r,
    __vue_module_identifier__$r,
    false,
    undefined,
    undefined,
    undefined
  );

var index = {
  getTranslations,
  verifyExtension,
};

//
const FilePond = vueFilePond__default["default"](
  FilePondPluginFileValidateType__default["default"],
  FilePondPluginFileValidateSize__default["default"],
  FilePondPluginFileEncode__default["default"]
);

var script$q = {
  name: "XerVueFilePondDemo",
  components: {
    FilePond,
  },
  data() {
    return {
      files: [],
    };
  },
  methods: {
    verifyExtension,
    getTranslations,
  },
};

/* script */
const __vue_script__$q = script$q;

/* template */
var __vue_render__$p = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c(
        "file-pond",
        _vm._b(
          {
            attrs: {
              name: "file-pond",
              "allow-multiple": true,
              "accepted-file-types":
                "image/jpeg, image/png, application/pdf, image/jpg",
              "max-file-size": "50MB",
              "max-total-file-size": "500MB",
              "file-validate-type-detect-type": function (source, type) {
                return _vm.verifyExtension(["png", "jpg", "pdf"], source, type)
              },
            },
            model: {
              value: _vm.files,
              callback: function ($$v) {
                _vm.files = $$v;
              },
              expression: "files",
            },
          },
          "file-pond",
          _vm.getTranslations(),
          false
        )
      ),
      _vm._v(" "),
      _c(
        "pre",
        [
          _vm._v("      Files:\n      "),
          _vm._l(_vm.files, function (file) {
            return _c("div", { key: file.id }, [
              _vm._v(
                "\n        id: " +
                  _vm._s(file.id) +
                  "\n        status: " +
                  _vm._s(file.status) +
                  "\n        size: " +
                  _vm._s(
                    !file.getFileEncodeBase64String()
                      ? "loading..."
                      : file.getFileEncodeBase64String().length
                  ) +
                  "\n      "
              ),
            ])
          }),
          _vm._v("\n    "),
        ],
        2
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$p = [];
__vue_render__$p._withStripped = true;

  /* style */
  const __vue_inject_styles__$q = undefined;
  /* scoped */
  const __vue_scope_id__$q = undefined;
  /* module identifier */
  const __vue_module_identifier__$q = undefined;
  /* functional template */
  const __vue_is_functional_template__$q = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$q = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
    __vue_inject_styles__$q,
    __vue_script__$q,
    __vue_scope_id__$q,
    __vue_is_functional_template__$q,
    __vue_module_identifier__$q,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$p = {
  name: "XerTextarea",
  components: { XerErrorList: __vue_component__$x },
  inheritAttrs: false,
  props: {
    xerCounter: {
      type: Boolean,
      default: false,
    },
    xerCounterLimit: {
      type: Number,
      default: 150,
    },
    xerShowCounterExceeded: {
      type: Boolean,
      default: false,
    },
    xerError: {
      type: Boolean,
      default: false,
    },
    xerErrorMessage: {
      type: [Array, String],
      default: () => [],
    },
    xerSingleError: {
      type: Boolean,
      default: false,
    },
    xerLabel: {
      type: String,
      required: false,
      default: "",
    },
    xerId: {
      type: String,
      required: false,
      default: "",
    },
    xerCaption: {
      type: String,
      required: false,
      default: "",
    },
    value: {
      type: null,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataAutomationId: {
      type: String,
      default: "textarea",
    },
  },
  data() {
    return {
      inputValue: this.value,
      characterCount: this.value ? this.value.length : 0,
    };
  },
  computed: {
    id() {
      return this.xerId || `xer-textarea_${vueUuid.uuid.v4()}`;
    },
    counterExceeded() {
      return this.characterCount > this.xerCounterLimit;
    },
    counter() {
      return this.characterCount + "/" + this.xerCounterLimit;
    },
    inputListeners() {
      const vm = this;
      return {
        ...this.$listeners,
        input(event) {
          vm.characterCount = event.target.value.length;
          vm.inputValue = event.target.value;
          vm.$emit("input", event.target.value);

          if (vm.characterCount > vm.xerCounterLimit) {
            vm.$emit("xer-character-limit");
          }

          // autogrow textarea
          const { textarea } = vm.$refs;
          textarea.style.height = textarea.scrollHeight + 2 + "px";
        },
      };
    },
  },
  watch: {
    value(newValue) {
      this.inputValue = newValue;
      this.characterCount = newValue ? newValue.length : 0;
    },
  },
};

/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$o = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "xer-textarea",
      class: {
        "xer-textarea--error": _vm.xerError,
        "xer-textarea--disabled": _vm.disabled,
        "xer-textarea--counter-error":
          _vm.xerShowCounterExceeded && _vm.counterExceeded,
      },
    },
    [
      _vm.xerLabel
        ? _c("label", {
            staticClass: "xer-textarea__label",
            attrs: {
              for: _vm.id,
              "data-automation-id": _vm.dataAutomationId + "_label",
            },
            domProps: { innerHTML: _vm._s(_vm.xerLabel) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "textarea",
        _vm._g(
          _vm._b(
            {
              ref: "textarea",
              staticClass: "xer-textarea__input",
              attrs: {
                id: _vm.id,
                disabled: _vm.disabled,
                "data-automation-id": _vm.dataAutomationId + "_input",
              },
              domProps: { value: _vm.inputValue },
            },
            "textarea",
            _vm.$attrs,
            false
          ),
          _vm.inputListeners
        )
      ),
      _vm._v(" "),
      _c("div", { staticClass: "xer-textarea-info" }, [
        _c(
          "div",
          [
            _vm.xerError
              ? _c("xer-error-list", {
                  staticClass: "xer-textarea__error",
                  attrs: {
                    "data-automation-id": _vm.dataAutomationId + "_error",
                    "xer-error-messages": _vm.xerErrorMessage,
                    "xer-single-error": _vm.xerSingleError,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.xerCaption
              ? _c("p", {
                  staticClass: "xer-caption xer-textarea__caption",
                  attrs: {
                    "data-automation-id": _vm.dataAutomationId + "_caption",
                  },
                  domProps: { innerHTML: _vm._s(_vm.xerCaption) },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.xerCounter
          ? _c("p", {
              staticClass: "xer-textarea__counter",
              attrs: {
                "data-automation-id": _vm.dataAutomationId + "_counter",
              },
              domProps: { textContent: _vm._s(_vm.counter) },
            })
          : _vm._e(),
      ]),
    ]
  )
};
var __vue_staticRenderFns__$o = [];
__vue_render__$o._withStripped = true;

  /* style */
  const __vue_inject_styles__$p = undefined;
  /* scoped */
  const __vue_scope_id__$p = undefined;
  /* module identifier */
  const __vue_module_identifier__$p = undefined;
  /* functional template */
  const __vue_is_functional_template__$p = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$p = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
    __vue_inject_styles__$p,
    __vue_script__$p,
    __vue_scope_id__$p,
    __vue_is_functional_template__$p,
    __vue_module_identifier__$p,
    false,
    undefined,
    undefined,
    undefined
  );

//

const types = ["info", "warning", "error", "success"];

var script$o = {
  name: "XerAlert",
  components: {
    XerIcon: __vue_component__$J,
  },
  model: {
    prop: "xerOpen",
    event: "xer-close",
  },
  props: {
    xerType: {
      type: String,
      required: false,
      default: "info",
      validator: (val) => types.includes(val),
    },
    xerOpen: {
      type: Boolean,
      required: true,
    },
    /** Configure if the animation should run or not */
    xerAnimate: {
      type: Boolean,
      default: true,
    },
    dataAutomationId: {
      type: String,
      default: "alert",
      required: false,
    },
  },
  data() {
    return {
      isOpen: this.xerOpen,
      showInDOM: this.xerOpen,
    };
  },
  computed: {
    alertIcon() {
      if (this.xerType === "success") return "check-circle";
      return this.xerType;
    },
  },
  watch: {
    xerOpen(newValue) {
      this.isOpen = newValue;
    },
    isOpen(newValue) {
      if (newValue) {
        this.showInDOM = newValue;
        return;
      }
      setTimeout(() => {
        if (!this.isOpen) {
          this.showInDOM = newValue;
        }
      }, 300);
    },
  },
  methods: {
    close() {
      this.isOpen = false;
      this.$emit("xer-close", false);
    },
  },
};

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.showInDOM
    ? _c(
        "div",
        {
          staticClass: "xer-alert",
          class: [
            "xer-alert--" + _vm.xerType,
            {
              "xer-alert--closed": !_vm.isOpen,
              "xer-alert--animate": _vm.xerAnimate,
            },
          ],
          attrs: { "data-automation-id": _vm.dataAutomationId },
        },
        [
          _c("xer-icon", {
            staticClass: "xer-alert__icon-type",
            attrs: { "xer-name": _vm.alertIcon },
          }),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "xer-alert__message" },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c("xer-icon", {
            staticClass: "xer-alert__icon-close",
            attrs: { "xer-name": "cross" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
};
var __vue_staticRenderFns__$n = [];
__vue_render__$n._withStripped = true;

  /* style */
  const __vue_inject_styles__$o = undefined;
  /* scoped */
  const __vue_scope_id__$o = undefined;
  /* module identifier */
  const __vue_module_identifier__$o = undefined;
  /* functional template */
  const __vue_is_functional_template__$o = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$o = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
    __vue_inject_styles__$o,
    __vue_script__$o,
    __vue_scope_id__$o,
    __vue_is_functional_template__$o,
    __vue_module_identifier__$o,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$n = {
  name: "XerAlertStack",
  components: {
    XerAlert: __vue_component__$o,
  },
  model: {
    prop: "xerAlerts",
  },
  props: {
    xerAlerts: {
      type: Array,
      required: true,
      default: () => [],
    },
    xerAutoClose: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    xerAlerts() {
      if (this.xerAutoClose) {
        this.xerAlerts.filter((alert) => !alert.timerStarted).forEach(this.startTimerForAlert);
      }
    },
  },
  mounted() {
    if (this.xerAutoClose) {
      this.xerAlerts.forEach(this.startTimerForAlert);
    }
  },
  methods: {
    startTimerForAlert(alert) {
      alert.timerStarted = true;

      setTimeout(() => {
        alert.open = false;
        // wait for animation to finish
        // eslint-disable-next-line vue/no-mutating-props
        setTimeout(() => this.xerAlerts.shift(), 1000);
      }, 5000);
    },
  },
};

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "xer-alert-stack" },
    _vm._l(_vm.xerAlerts, function (alert, index) {
      return _c(
        "div",
        { key: alert.message },
        [
          _c(
            "xer-alert",
            {
              attrs: { "xer-type": alert.type },
              model: {
                value: alert.open,
                callback: function ($$v) {
                  _vm.$set(alert, "open", $$v);
                },
                expression: "alert.open",
              },
            },
            [_c("div", { domProps: { innerHTML: _vm._s(alert.message) } })]
          ),
          _vm._v(" "),
          index !== _vm.xerAlerts.length - 1
            ? _c("div", { staticClass: "xer-alert-stack__spacer" })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
};
var __vue_staticRenderFns__$m = [];
__vue_render__$m._withStripped = true;

  /* style */
  const __vue_inject_styles__$n = undefined;
  /* scoped */
  const __vue_scope_id__$n = undefined;
  /* module identifier */
  const __vue_module_identifier__$n = undefined;
  /* functional template */
  const __vue_is_functional_template__$n = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$n = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
    __vue_inject_styles__$n,
    __vue_script__$n,
    __vue_scope_id__$n,
    __vue_is_functional_template__$n,
    __vue_module_identifier__$n,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$m = {
  name: "XerDropdown",
  props: {
    xerSelectedOption: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentOption: {},
      icon: "chevron-down",
    };
  },
  watch: {
    xerSelectedOption(newValue) {
      this.currentOption = newValue;
    },
  },
  mounted() {
    if (this.xerSelectedOption) {
      this.currentOption = this.xerSelectedOption;
    }
  },
  methods: {
    setShowOptions() {
      this.icon = "chevron-up";
    },
    setHideOptions() {
      this.icon = "chevron-down";
    },
    toggleOptions() {
      if (this.icon === "chevron-up") {
        this.setHideOptions();
      } else if (this.icon === "chevron-down") {
        this.setShowOptions();
      }
    },
    selectOption(option) {
      this.currentOption = option;
      this.setHideOptions();
      this.$emit("xer-update-selected-option", option);
    },
  },
};

/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _vm._t("default", null, {
        xerIcon: _vm.icon,
        xerAutoShowOptions: true,
        xerReadonly: true,
        value: _vm.currentOption.label,
        xerDisableClearIcon: true,
        selectOption: _vm.selectOption,
        setShowOptions: _vm.setShowOptions,
        setHideOptions: _vm.setHideOptions,
        toggleOptions: _vm.toggleOptions,
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__$l = [];
__vue_render__$l._withStripped = true;

  /* style */
  const __vue_inject_styles__$m = undefined;
  /* scoped */
  const __vue_scope_id__$m = undefined;
  /* module identifier */
  const __vue_module_identifier__$m = undefined;
  /* functional template */
  const __vue_is_functional_template__$m = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$m = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
    __vue_inject_styles__$m,
    __vue_script__$m,
    __vue_scope_id__$m,
    __vue_is_functional_template__$m,
    __vue_module_identifier__$m,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$l = {
  name: "XerAutocomplete",
  props: {
    xerOptions: {
      type: Array,
      default: () => [],
    },
    xerSelectedOption: {
      type: Object,
      default: () => ({}),
    },
    xerDebounce: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      currentOption: {},
      loading: false,
      debounceFunc: null,
    };
  },
  watch: {
    xerSelectedOption(newValue) {
      this.currentOption = newValue;
    },
    xerOptions() {
      this.loading = false;
    },
  },
  mounted() {
    if (this.xerSelectedOption) {
      this.currentOption = this.xerSelectedOption;
    }

    this.debounceFunc = lodashEs.debounce((value) => {
      this.$emit("xer-update-input-value", value);
    }, this.xerDebounce);
  },
  methods: {
    setOption(option) {
      this.currentOption = option;
      this.$emit("xer-update-selected-option", option);
    },
    debounceInput(value) {
      this.setOption({ label: value });
      if (value) this.loading = true;
      this.debounceFunc(value);
    },
  },
};

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _vm._t("default", null, {
        xerLoading: _vm.loading,
        xerIcon: "magnifying-glass",
        xerAutoShowOptions: true,
        xerOptions: _vm.xerOptions,
        value: _vm.currentOption.label,
        selectOption: _vm.setOption,
        debounceInput: _vm.debounceInput,
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__$k = [];
__vue_render__$k._withStripped = true;

  /* style */
  const __vue_inject_styles__$l = undefined;
  /* scoped */
  const __vue_scope_id__$l = undefined;
  /* module identifier */
  const __vue_module_identifier__$l = undefined;
  /* functional template */
  const __vue_is_functional_template__$l = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$l = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
    __vue_inject_styles__$l,
    __vue_script__$l,
    __vue_scope_id__$l,
    __vue_is_functional_template__$l,
    __vue_module_identifier__$l,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$k = {
  name: "XerSlider",
  components: {
    VueSlider: VueSlider__default["default"],
  },
};

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "vue-slider",
    _vm._g(
      _vm._b(
        { attrs: { "dot-size": "24", tooltip: "always" } },
        "vue-slider",
        _vm.$attrs,
        false
      ),
      _vm.listeners
    )
  )
};
var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;

  /* style */
  const __vue_inject_styles__$k = undefined;
  /* scoped */
  const __vue_scope_id__$k = undefined;
  /* module identifier */
  const __vue_module_identifier__$k = undefined;
  /* functional template */
  const __vue_is_functional_template__$k = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$k = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$k,
    __vue_script__$k,
    __vue_scope_id__$k,
    __vue_is_functional_template__$k,
    __vue_module_identifier__$k,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$j = {
  name: "XerTabs",
  props: {
    xerActiveTab: {
      type: String,
      required: false,
      default: "",
    },
    xerTabs: {
      type: Array,
      default: () => [],
    },
    xerHorizontalScroll: {
      type: Boolean,
      default: false,
    },
    dataAutomationId: {
      type: String,
      default: "tab",
      required: false,
    },
  },
  data() {
    return {
      activeTab: "",
    };
  },
  watch: {
    xerActiveTab(tab) {
      this.activeTab = tab;
    },
  },
  mounted() {
    this.activeTab = this.xerActiveTab;
  },
  methods: {
    selectTab(tabName) {
      this.activeTab = tabName;
      this.$emit("xer-select-tab", tabName);
    },
  },
};

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: { "xer-tabs__horizontal-scroll": _vm.xerHorizontalScroll } },
    [
      _c(
        "ul",
        {
          staticClass: "xer-tabs",
          class: {
            "xer-tabs__horizontal-scroll__border": _vm.xerHorizontalScroll,
          },
        },
        _vm._l(_vm.xerTabs, function (tab, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "xer-tabs__tab",
              class: { "xer-tabs__tab--active": tab.name === _vm.activeTab },
              attrs: {
                "data-automation-id": _vm.dataAutomationId + "_" + index,
              },
              on: {
                click: function ($event) {
                  return _vm.selectTab(tab.name)
                },
              },
            },
            [_c("span", { domProps: { innerHTML: _vm._s(tab.content) } })]
          )
        }),
        0
      ),
    ]
  )
};
var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;

  /* style */
  const __vue_inject_styles__$j = undefined;
  /* scoped */
  const __vue_scope_id__$j = undefined;
  /* module identifier */
  const __vue_module_identifier__$j = undefined;
  /* functional template */
  const __vue_is_functional_template__$j = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$j = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$i = {
  name: "XerButtonGroup",
  props: {
    xerActiveButton: {
      type: String,
      required: false,
      default: "",
    },
    xerButtons: {
      type: Array,
      default: () => [],
    },
    dataAutomationId: {
      type: String,
      default: "group_button",
      required: false,
    },
  },
  data() {
    return {
      activeButton: "",
    };
  },
  watch: {
    xerActiveButton(button) {
      this.activeButton = button;
    },
  },
  mounted() {
    this.activeButton = this.xerActiveButton;
  },
  methods: {
    selectButton(buttonName) {
      if (this.activeButton === buttonName) {
        this.activeButton = null;
        return this.$emit("xer-select-button", null);
      }

      this.activeButton = buttonName;
      this.$emit("xer-select-button", buttonName);
    },
  },
};

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "xer-button-group" },
    _vm._l(_vm.xerButtons, function (button, index) {
      return _c(
        "div",
        {
          key: button.name,
          staticClass: "xer-button-group__button",
          class: [
            { "xer-button-group__button--left": index === 0 },
            {
              "xer-button-group__button--right":
                index === _vm.xerButtons.length - 1,
            },
            {
              "xer-button-group__button--active":
                _vm.activeButton === button.name,
            },
          ],
          attrs: { "data-automation-id": _vm.dataAutomationId + "_" + index },
          domProps: { innerHTML: _vm._s(button.content) },
          on: {
            click: function ($event) {
              return _vm.selectButton(button.name)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(index) + "\n  ")]
      )
    }),
    0
  )
};
var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;

  /* style */
  const __vue_inject_styles__$i = undefined;
  /* scoped */
  const __vue_scope_id__$i = undefined;
  /* module identifier */
  const __vue_module_identifier__$i = undefined;
  /* functional template */
  const __vue_is_functional_template__$i = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$i = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$h = {
  name: "XerPagination",
  components: {
    XerIcon: __vue_component__$J,
  },
  props: {
    xerTotal: {
      type: Number,
      required: true,
    },
    xerPageTotal: {
      type: Number,
      required: true,
    },
    xerCurrentPage: {
      type: Number,
      default: 1,
    },
    dataAutomationId: {
      type: String,
      default: "pagination",
      required: false,
    },
  },
  data() {
    return {
      currentPage: this.xerCurrentPage,
    };
  },
  computed: {
    range() {
      if (this.pages.length <= 6) {
        return this.pages.slice(1, this.pages.length - 1);
      }
      if (this.currentPage < 6) {
        return [2, 3, 4, 5, 6];
      }
      // always show a range of 5 numbers which shift depending on the current page
      if (this.currentPage > this.pages[this.pages.length - 6]) {
        return this.pages.slice(this.pages.length - 6, this.pages.length - 1);
      }
      return this.pages.slice(this.currentPage - 4, this.currentPage + 1);
    },
    pages() {
      const totalPages = Math.ceil(this.xerTotal / this.xerPageTotal);
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    },
  },
  watch: {
    xerCurrentPage(page) {
      this.currentPage = page;
    },
  },
  methods: {
    previous() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.$emit("xer-page-change", this.currentPage);
      }
    },
    next() {
      if (this.currentPage < this.pages[this.pages.length - 1]) {
        this.currentPage += 1;
        this.$emit("xer-page-change", this.currentPage);
      }
    },
    select(number) {
      this.currentPage = number;
      this.$emit("xer-page-change", this.currentPage);
    },
  },
};

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "xer-pagination" },
    [
      _c("xer-icon", {
        staticClass: "xer-pagination__arrow",
        attrs: {
          "data-automation-id": _vm.dataAutomationId + "_previous",
          "xer-color": "grey-6",
          "xer-name": "chevron-left",
        },
        on: {
          click: function ($event) {
            return _vm.previous()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "xer-pagination__number",
          class: [
            {
              "xer-pagination__number--active":
                _vm.currentPage === _vm.pages[0],
            },
          ],
          attrs: { "data-automation-id": _vm.dataAutomationId + "_first" },
          on: {
            click: function ($event) {
              return _vm.select(_vm.pages[0])
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.pages[0]) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.range[0] !== _vm.pages[1] && _vm.pages.length > 2
        ? _c("div", { staticClass: "xer-pagination__dots" }, [_vm._v("...")])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.range, function (number) {
        return _c(
          "div",
          {
            key: number,
            staticClass: "xer-pagination__number",
            class: [
              { "xer-pagination__number--active": _vm.currentPage === number },
            ],
            attrs: {
              "data-automation-id": _vm.dataAutomationId + "_" + number,
            },
            on: {
              click: function ($event) {
                return _vm.select(number)
              },
            },
          },
          [_vm._v("\n    " + _vm._s(number) + "\n  ")]
        )
      }),
      _vm._v(" "),
      _vm.range[_vm.range.length - 1] !== _vm.pages[_vm.pages.length - 2] &&
      _vm.pages.length > 2
        ? _c("div", { staticClass: "xer-pagination__dots" }, [
            _vm._v("\n    ...\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.pages.length > 1
        ? _c(
            "div",
            {
              staticClass: "xer-pagination__number",
              class: [
                {
                  "xer-pagination__number--active":
                    _vm.currentPage === _vm.pages[_vm.pages.length - 1],
                },
              ],
              attrs: { "data-automation-id": _vm.dataAutomationId + "_last" },
              on: {
                click: function ($event) {
                  return _vm.select(_vm.pages[_vm.pages.length - 1])
                },
              },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.pages[_vm.pages.length - 1]) + "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("xer-icon", {
        staticClass: "xer-pagination__arrow",
        attrs: {
          "data-automation-id": _vm.dataAutomationId + "_next",
          "xer-color": "grey-6",
          "xer-name": "chevron-right",
        },
        on: {
          click: function ($event) {
            return _vm.next()
          },
        },
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;

  /* style */
  const __vue_inject_styles__$h = undefined;
  /* scoped */
  const __vue_scope_id__$h = undefined;
  /* module identifier */
  const __vue_module_identifier__$h = undefined;
  /* functional template */
  const __vue_is_functional_template__$h = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$h = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    undefined,
    undefined,
    undefined
  );

const bus = new Vue__default["default"]();

const COLUMN_CLICK_EVENT = "column-click-event";
const SUBMIT_FILTERS_EVENT = "submit-filters-event";
const getEventBus = () => bus;

//

var script$g = {
  name: "XerTable",
  components: {
    XerPagination: __vue_component__$h,
  },
  inheritAttrs: false,
  props: {
    xerData: {
      type: Array,
      default: () => [],
    },
    xerTotal: {
      type: Number,
      default: 0,
    },
    xerPageTotal: {
      type: Number,
      default: 10,
    },
    xerResponsive: {
      type: Boolean,
      default: true,
    },
    xerDescription: {
      type: String,
      required: true,
    },
    xerCurrentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      currentPage: this.xerCurrentPage,
      currentPageData: this.xerData,
    };
  },
  watch: {
    xerData(data) {
      this.currentPageData = data;
    },
    xerCurrentPage(page) {
      this.currentPage = page;
    },
  },
  created() {
    getEventBus().$on(COLUMN_CLICK_EVENT, (data) => {
      this.$emit("xer-order-change", data);
    });
    getEventBus()
      .$on(SUBMIT_FILTERS_EVENT, (data) => this.$emit("xer-submit-filters", data));
  },
  methods: {
    onPageChange(page) {
      this.$emit("xer-page-change", page);
    },
  },
};

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$f = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "xer-data-table",
      class:
        ((_obj = {}),
        (_obj["xer-data-table--responsive"] = _vm.xerResponsive),
        _obj),
    },
    [
      _c(
        "table",
        { attrs: { "aria-describedby": _vm.xerDescription } },
        [
          _c(
            "tr",
            { staticClass: "xer-data-table__header-row" },
            [_vm._t("headers")],
            2
          ),
          _vm._v(" "),
          _vm._l(_vm.currentPageData, function (item, index) {
            return _c(
              "tr",
              { key: index, staticClass: "xer-data-table__cell-row" },
              [_vm._t("cells", null, { xerItem: item })],
              2
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("xer-pagination", {
        staticClass: "xer-data-table__pagination",
        attrs: {
          "xer-total": _vm.xerTotal,
          "xer-page-total": _vm.xerPageTotal,
          "xer-current-page": _vm.currentPage,
        },
        on: { "xer-page-change": _vm.onPageChange },
      }),
    ],
    1
  )
};
var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;

  /* style */
  const __vue_inject_styles__$g = undefined;
  /* scoped */
  const __vue_scope_id__$g = undefined;
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$g = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//

var script$f = {
  name: "XerTableCell",
  components: {},
  props: {
    xerName: {
      type: String,
      required: false,
      default: "",
    },
    dataAutomationId: {
      type: String,
      default: "data_table_cell",
      required: false,
    },
  },
};

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "td",
    _vm._b(
      {
        staticClass: "xer-data-table__cell",
        attrs: {
          "data-automation-id": _vm.dataAutomationId,
          "data-name": _vm.xerName,
        },
      },
      "td",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;

  /* style */
  const __vue_inject_styles__$f = undefined;
  /* scoped */
  const __vue_scope_id__$f = undefined;
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$e = {
  name: "XerTableHeader",
  components: {
    XerIcon: __vue_component__$J,
  },
  props: {
    xerName: {
      type: String,
      required: true,
    },
    xerSortable: {
      type: Boolean,
      default: true,
    },
    dataAutomationId: {
      type: String,
      default: "table_header",
      required: false,
    },
  },
  data() {
    return {
      sort: "asc",
      sortActive: false,
    };
  },
  created() {
    getEventBus().$on(COLUMN_CLICK_EVENT, (data) => {
      if (data.name !== this.xerName) {
        this.sort = "asc";
        this.sortActive = false;
      }
    });
  },
  methods: {
    onColumnClick() {
      if (!this.xerSortable) {
        return;
      }

      this.sort = this.sort === "asc" ? "desc" : "asc";
      this.sortActive = true;
      getEventBus()
        .$emit(COLUMN_CLICK_EVENT, { name: this.xerName, order: this.sort });
    },
  },
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "th",
    _vm._b(
      {
        staticClass: "xer-data-table__header",
        attrs: { "data-automation-id": _vm.dataAutomationId, scope: "col" },
        on: {
          click: function ($event) {
            return _vm.onColumnClick()
          },
        },
      },
      "th",
      _vm.$attrs,
      false
    ),
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.xerSortable
        ? _c("xer-icon", {
            staticClass: "xer-data-table__header-icon",
            attrs: {
              "xer-name": _vm.sort === "asc" ? "chevron-up" : "chevron-down",
              "xer-color": _vm.sortActive ? "primary" : "grey",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("filter-popover"),
    ],
    2
  )
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;

  /* style */
  const __vue_inject_styles__$e = undefined;
  /* scoped */
  const __vue_scope_id__$e = undefined;
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$d = {
  name: "XerPopover",
  components: {},
  props: {
    dataAutomationId: {
      type: String,
      default: "popover",
      required: false,
    },
  },
  data() {
    return {
      popperInstance: null,
      shown: false,
    };
  },
  mounted() {
    const getTriggerElement = (el) => {
      const { context } = el;
      if (context.$children[0] && context.$children[0].$children[0]) {
        return context.$children[0].$children[0].$el;
      }
    };

    const trigger = getTriggerElement(this.$scopedSlots.trigger()[0]);
    const popover = this.$refs.popover;

    this.popperInstance = popperLite_js.createPopper(trigger, popover, {
      placement: "bottom",
      modifiers: [
        flip__default["default"],
        offset__default["default"],
        {
          name: "flip",
          options: {
            fallbackPlacements: ["top"],
          },
        },
        {
          name: "offset",
          options: {
            offset: [0, 5],
          },
        },
      ],
    });
  },
  methods: {
    showPopover() {
      this.shown = true;
      this.$refs.popover.setAttribute("data-show", "");
      this.popperInstance.update();
    },
    hide() {
      this.$refs.popover.removeAttribute("data-show");
      this.shown = false;
    },
  },
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    [
      _vm._t("trigger", null, { showPopover: _vm.showPopover }),
      _vm._v(" "),
      _vm.shown
        ? _c("div", {
            staticClass: "xer-popover__backdrop",
            attrs: { "data-automation-id": _vm.dataAutomationId + "_backdrop" },
            on: { click: _vm.hide },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { ref: "popover", staticClass: "xer-popover" },
        [_vm._t("content", null, { hidePopover: _vm.hide })],
        2
      ),
    ],
    2
  )
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;

  /* style */
  const __vue_inject_styles__$d = undefined;
  /* scoped */
  const __vue_scope_id__$d = undefined;
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$c = {
  name: "XerTableFilterPopover",
  components: {
    XerButton: __vue_component__$H,
    XerOptionInputList: __vue_component__$t,
    XerOptionInput: __vue_component__$u,
    XerPopover: __vue_component__$d,
    XerIcon: __vue_component__$J,
  },
  props: {
    xerFilterOptions: {
      type: Array,
      default: () => [],
    },
    xerFilterActive: {
      type: Boolean,
      required: false,
    },
    dataAutomationId: {
      type: String,
      default: "table_filter",
      required: false,
    },
  },
  data() {
    return {
      checkedOptions: {},
    };
  },
  created() {
    this.xerFilterOptions.forEach((option) => {
      this.checkedOptions[option.key] = option.active;
    });
  },
  methods: {
    submit(hidePopover) {
      getEventBus().$emit(
        SUBMIT_FILTERS_EVENT,
        Object.entries(this.checkedOptions).reduce((acc, [key, value]) => {
          acc.push({
            key,
            active: value,
          });
          return acc;
        }, [])
      );
      hidePopover();
    },
  },
};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("xer-popover", {
    scopedSlots: _vm._u(
      [
        {
          key: "trigger",
          fn: function (props) {
            return [
              _c("xer-icon", {
                staticClass: "xer-data-table__header-icon",
                attrs: {
                  "xer-name": "edit",
                  "data-automation-id": _vm.dataAutomationId + "_icon",
                  "xer-color": _vm.xerFilterActive ? "primary" : "grey",
                },
                on: { click: props.showPopover },
              }),
            ]
          },
        },
        {
          key: "content",
          fn: function (props) {
            return [
              _c(
                "div",
                {
                  staticClass: "xer-data-table__popover",
                  attrs: {
                    "data-automation-id": _vm.dataAutomationId + "_popover",
                  },
                },
                [
                  _c(
                    "xer-option-input-list",
                    _vm._l(_vm.xerFilterOptions, function (option) {
                      return _c("xer-option-input", {
                        key: option.key,
                        attrs: {
                          "xer-type": "checkbox",
                          "data-automation-id":
                            _vm.dataAutomationId + "_popover_item",
                          "xer-label": option.key,
                        },
                        model: {
                          value: _vm.checkedOptions[option.key],
                          callback: function ($$v) {
                            _vm.$set(_vm.checkedOptions, option.key, $$v);
                          },
                          expression: "checkedOptions[option.key]",
                        },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "xer-button",
                    {
                      staticClass: "xer-data-table__popover-button",
                      attrs: {
                        "data-automation-id": _vm.dataAutomationId + "_submit",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submit(props.hidePopover)
                        },
                      },
                    },
                    [_vm._t("default")],
                    2
                  ),
                ],
                1
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;

  /* style */
  const __vue_inject_styles__$c = undefined;
  /* scoped */
  const __vue_scope_id__$c = undefined;
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$b = {
  name: "XerDemoTable",
  components: {
    XerTable: __vue_component__$g,
    XerIcon: __vue_component__$J,
    XerTableFilterPopover: __vue_component__$c,
    XerTableHeader: __vue_component__$e,
    XerTableCell: __vue_component__$f,
  },
  inheritAttrs: false,
  props: {},
  data() {
    return {
      dataset: [],
      currentPage: 1,
      pageTotal: 5,
      lastSortData: undefined,
    };
  },
  computed: {
    datasetTotal() {
      return this.dataset.length;
    },
    datasetPage() {
      if (this.currentPage === 1) {
        return this.dataset.slice(0, this.pageTotal);
      }
      return this.dataset.slice(
        (this.currentPage - 1) * this.pageTotal,
        (this.currentPage - 1) * this.pageTotal + this.pageTotal
      );
    },
  },
  created() {
    this.resetDataset();
  },
  methods: {
    resetDataset() {
      this.dataset = [..."abcdefghijklmnopqrstuvwxyz"].map((letter, i) => ({
        name: letter,
        rating: i,
        status: i % 2 === 0 ? "Open" : "Closed",
      }));
    },
    changeSort(sortData) {
      this.lastSortData = sortData;
      if (sortData.order === "desc") {
        this.dataset = lodashEs.orderBy(this.dataset, [sortData.name], ["desc"]);
      } else if (sortData.order === "asc") {
        this.dataset = lodashEs.orderBy(this.dataset, [sortData.name], ["asc"]);
      }
    },
    changePage(page) {
      this.currentPage = page;
    },
    filterDatasetByStatus(filters) {
      this.resetDataset();
      const activeFilters = filters.filter((f) => f.active === true).map((f) => f.key);
      if (activeFilters.length !== 0) {
        this.dataset = this.dataset.filter((item) => activeFilters.includes(item.status));
      }
      if (!!this.lastSortData) {
        this.changeSort(this.lastSortData);
      }
      this.changePage(1);
    },
  },
};

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("xer-table", {
    attrs: {
      "xer-data": _vm.datasetPage,
      "xer-total": _vm.datasetTotal,
      "xer-page-total": _vm.pageTotal,
      "xer-description": "Demo table",
    },
    on: {
      "xer-order-change": _vm.changeSort,
      "xer-page-change": _vm.changePage,
      "xer-submit-filters": _vm.filterDatasetByStatus,
    },
    scopedSlots: _vm._u([
      {
        key: "headers",
        fn: function () {
          return [
            _c("xer-table-header", { attrs: { "xer-name": "name" } }, [
              _vm._v(" Name "),
            ]),
            _vm._v(" "),
            _c("xer-table-header", { attrs: { "xer-name": "rating" } }, [
              _vm._v(" Rating "),
            ]),
            _vm._v(" "),
            _c(
              "xer-table-header",
              {
                attrs: { "xer-sortable": false, "xer-name": "status" },
                scopedSlots: _vm._u([
                  {
                    key: "filter-popover",
                    fn: function () {
                      return [
                        _c(
                          "xer-table-filter-popover",
                          {
                            attrs: {
                              "xer-filter-active": true,
                              "xer-filter-options": [
                                { key: "Open", active: false },
                                { key: "Closed", active: false },
                              ],
                            },
                          },
                          [_vm._v("\n          Filter\n        ")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [_vm._v("\n      Status\n      ")]
            ),
            _vm._v(" "),
            _c("xer-table-header", {
              attrs: { "xer-sortable": false, "xer-name": "actions" },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "cells",
        fn: function (ref) {
          var xerItem = ref.xerItem;
          return [
            _c("xer-table-cell", { attrs: { "xer-name": "name" } }, [
              _vm._v("\n      " + _vm._s(xerItem.name) + "\n    "),
            ]),
            _vm._v(" "),
            _c("xer-table-cell", { attrs: { "xer-name": "rating" } }, [
              _vm._v("\n      " + _vm._s(xerItem.rating) + "\n    "),
            ]),
            _vm._v(" "),
            _c("xer-table-cell", { attrs: { "xer-name": "status" } }, [
              _vm._v("\n      " + _vm._s(xerItem.status) + "\n    "),
            ]),
            _vm._v(" "),
            _c(
              "xer-table-cell",
              [
                _c("xer-icon", {
                  attrs: { "xer-name": "gear", "xer-color": "grey" },
                }),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
};
var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;

  /* style */
  const __vue_inject_styles__$b = undefined;
  /* scoped */
  const __vue_scope_id__$b = undefined;
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    undefined,
    undefined,
    undefined
  );

const { reactiveProp } = vueChartjs.mixins;

var script$a = {
  name: "XerDoughnutChart",
  extends: vueChartjs.Doughnut,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default: () => ({
        cutoutPercentage: 85,
        legend: {
          display: false,
        },
      }),
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};

/* script */
const __vue_script__$a = script$a;

/* template */

  /* style */
  const __vue_inject_styles__$a = undefined;
  /* scoped */
  const __vue_scope_id__$a = undefined;
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    undefined,
    undefined,
    undefined
  );

const colors = [
  "#ed8b00", // primary,
  "#ef426f", // secondary-1
  "#991e66", // secondary-2,
];

var chartHelper = {
  colors,
};

//

var script$9 = {
  name: "XerDemoDoughnutChart",
  components: {
    XerButton: __vue_component__$H,
    XerDoughnutChart: __vue_component__$a,
  },
  data() {
    return {
      datacollection: null,
    };
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: ["Data one", "Data two", "Data three"],
        datasets: [
          {
            data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt()],
            backgroundColor: colors,
          },
        ],
      };
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
  },
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticStyle: { "max-width": "200px" } },
    [
      _vm.datacollection
        ? _c("xer-doughnut-chart", {
            attrs: { "chart-data": _vm.datacollection },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "xer-mt-6 xer-flex xer-justify-center" },
        [
          _c(
            "xer-button",
            {
              on: {
                click: function ($event) {
                  return _vm.fillData()
                },
              },
            },
            [_vm._v(" Randomize ")]
          ),
        ],
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;

  /* style */
  const __vue_inject_styles__$9 = undefined;
  /* scoped */
  const __vue_scope_id__$9 = undefined;
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    undefined,
    undefined,
    undefined
  );

//

Vue__default["default"].use(VCalendar__default["default"], {
  datePicker: {
    popover: {
      visibility: "focus",
    },
  },
});

var script$8 = {
  name: "XerDatepicker",
  components: {
    XerTextfield: __vue_component__$w,
  },
  props: {
    xerLabel: {
      type: String,
      default: "Datum",
    },
    value: {
      type: null,
      default: null,
    },
  },
  computed: {
    inputListeners() {
      const vm = this;
      return {
        ...this.$listeners,
        input(event) {
          vm.dateValue = event;
          vm.$emit("input", event);
        },
      };
    },
  },
};

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "v-date-picker",
    _vm._g(
      _vm._b(
        {
          attrs: { value: _vm.value, color: "orange" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (ref) {
                var inputValue = ref.inputValue;
                var inputEvents = ref.inputEvents;
                var togglePopover = ref.togglePopover;
                return [
                  _c(
                    "xer-textfield",
                    _vm._g(
                      {
                        attrs: {
                          "xer-icon": "calendar",
                          "xer-label": _vm.xerLabel,
                          "xer-is-date-picker": "",
                          value: inputValue,
                        },
                        on: { "xer-icon-click": togglePopover },
                      },
                      inputEvents
                    )
                  ),
                ]
              },
            },
          ]),
        },
        "v-date-picker",
        _vm.$attrs,
        false
      ),
      _vm.inputListeners
    )
  )
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

  /* style */
  const __vue_inject_styles__$8 = undefined;
  /* scoped */
  const __vue_scope_id__$8 = undefined;
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$7 = {
  name: "XerBreadcrumbLink",
  components: {
    XerIcon: __vue_component__$J,
  },
  props: {
    xerLink: {
      type: String,
      default: "/",
    },
    xerType: {
      type: String,
      default: "router-link",
    },
    dataAutomationId: {
      type: String,
      default: "breadcrumb-link",
      required: false,
    },
  },
};

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.xerType,
    {
      tag: "component",
      staticClass: "xer-breadcrumb--link",
      attrs: { to: _vm.xerLink, "data-automation-id": _vm.dataAutomationId },
    },
    [
      _vm._t("default", function () {
        return [
          _c("xer-icon", { attrs: { "xer-name": "home", "xer-size": "5" } }),
        ]
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = undefined;
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$6 = {
  name: "XerBreadcrumbItem",
  components: {
    XerIcon: __vue_component__$J,
  },
  props: {
    xerIsLast: {
      type: Boolean,
      default: null,
    },
    dataAutomationId: {
      type: String,
      default: "breadcrumb-item",
      required: false,
    },
  },
  data() {
    return {
      isLastChild: this.xerIsLast,
    };
  },
  mounted() {
    if (this.$el.nextElementSibling === null && this.xerIsLast === null) {
      this.isLastChild = true;
    }
  },
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "li",
    {
      staticClass: "xer-breadcrumb--item",
      class: {
        "xer-breadcrumb--last-child": _vm.isLastChild,
        "xer-breadcrumb--not-last-child": !_vm.isLastChild,
      },
      attrs: { "data-automation-id": _vm.dataAutomationId },
    },
    [
      _vm.isLastChild
        ? _c("xer-icon", {
            staticClass: "xer-breadcrumb__icon-chevron--left",
            attrs: { "xer-name": "chevron-left", "xer-size": "4" },
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      !_vm.isLastChild
        ? _c("xer-icon", {
            staticClass: "xer-breadcrumb__icon-chevron--right",
            attrs: { "xer-name": "chevron-right", "xer-size": "4" },
          })
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  const __vue_inject_styles__$6 = undefined;
  /* scoped */
  const __vue_scope_id__$6 = undefined;
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$5 = {
  name: "XerBreadcrumb",
  components: {
    XerBreadcrumbLink: __vue_component__$7,
    XerBreadcrumbItem: __vue_component__$6,
    XerIcon: __vue_component__$J,
  },
  props: {
    xerCrumbs: {
      type: Array,
      default: () => [],
    },
    xerType: {
      type: String,
      default: "router-link",
    },
    dataAutomationId: {
      type: String,
      default: "breadcrumb",
      required: false,
    },
  },
  data() {
    return {
      lastChildId: "",
    };
  },
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "nav",
    {
      staticClass: "xer-breadcrumb",
      attrs: {
        "aria-label": "breadcrumb",
        "data-automation-id": _vm.dataAutomationId,
      },
    },
    [
      _c(
        "ol",
        [
          _vm._t("default", function () {
            return [
              _c(
                "xer-breadcrumb-item",
                {
                  attrs: {
                    "data-automation-id": _vm.dataAutomationId + "-item",
                  },
                },
                [
                  _c("xer-breadcrumb-link", {
                    attrs: { "xer-type": _vm.xerType },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.xerCrumbs, function (crumb, i) {
                return _c(
                  "xer-breadcrumb-item",
                  {
                    key: i,
                    attrs: {
                      "data-automation-id": _vm.dataAutomationId + "-item",
                    },
                  },
                  [
                    _c(
                      "xer-breadcrumb-link",
                      {
                        attrs: {
                          "xer-link": crumb.path,
                          "xer-type": _vm.xerType,
                          "data-automation-id": _vm.dataAutomationId + "-link",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(crumb.text) + "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.xerCrumbs.length === i + 1
                      ? _c("xer-icon", {
                          staticClass: "xer-breadcrumb__icon--right",
                          attrs: {
                            "xer-name": "chevron-right",
                            "xer-size": "4",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ]
          }),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$4 = {
  name: "XerApplicationShell",
  components: {
    XerIcon: __vue_component__$J,
  },
  props: {
    /** Render admin application layout */
    xerAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      cdnUrl:
        variables_1 +
        "/style/" +
        codeyUtilsVue2.versionHelper.getVersion(packageJson, "@xerius/codey-style-vue2"),
    };
  },
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "xer-application-content",
      class:
        "xer-codey xer-l-application " +
        (_vm.xerAdmin ? "xer-l-application--admin" : ""),
    },
    [
      _vm._t("header"),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass:
            "xer-l-application__main xer-t-application-main xer-card xer-card--xxxl",
          attrs: { role: "main" },
        },
        [_vm._t("content")],
        2
      ),
      _vm._v(" "),
      _c(
        "footer",
        {
          staticClass:
            "xer-l-application__footer xer-t-application-footer xer-footer",
        },
        [
          _c("img", {
            staticClass: "xer-footer__logo",
            attrs: {
              src: _vm.cdnUrl + "/assets/images/xerius/logo-name.svg",
              alt: "logo",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "xer-footer__content" }, [
            _c("div", { staticClass: "xer-footer-info" }, [_vm._t("links")], 2),
            _vm._v(" "),
            _c("div", { staticClass: "xer-footer-social" }, [
              _c(
                "a",
                {
                  staticClass: "xer-link xer-link--icon",
                  attrs: {
                    target: "_blank",
                    "aria-label": "linkedin.",
                    href: "https://be.linkedin.com/company/xerius",
                    "data-automation-id": "linkedin-icon",
                    rel: "noreferrer",
                  },
                },
                [
                  _c("xer-icon", {
                    attrs: {
                      "xer-name": "linkedin",
                      "aria-label": "linkedin.",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "xer-link xer-link--icon",
                  attrs: {
                    target: "_blank",
                    "aria-label": "facebook.",
                    href: "https://www.facebook.com/xerius.be/",
                    "data-automation-id": "facebook-icon",
                    rel: "noreferrer",
                  },
                },
                [
                  _c("xer-icon", {
                    attrs: {
                      "xer-name": "facebook",
                      "aria-label": "facebook.",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    2
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$3 = {
  name: "XerToggleSwitch",
  inheritAttrs: false,
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: null,
      default: null,
    },
    dataAutomationId: {
      type: String,
      default: "toggle_switch",
      required: false,
    },
  },
  computed: {
    inputListeners() {
      const vm = this;
      return {
        ...this.$listeners,
        change(event) {
          vm.$emit("change", event.target.checked);
        },
      };
    },
  },
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "xer-toggle-switch" }, [
    _c(
      "input",
      _vm._g(
        {
          staticClass: "xer-toggle-switch__input",
          attrs: {
            disabled: _vm.disabled,
            type: "checkbox",
            "data-automation-id": _vm.dataAutomationId + "_input",
          },
          domProps: { checked: _vm.checked },
        },
        _vm.inputListeners
      )
    ),
    _vm._v(" "),
    _c("div", { staticClass: "xer-toggle-switch__switch" }),
  ])
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$2 = {
  name: "XerAccordionHeader",
  components: {
    XerIcon: __vue_component__$J,
  },
  props: {
    dataAutomationId: {
      type: String,
      default: "accordion-header",
      required: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleAccordionItem() {
      this.isOpen = !this.isOpen;
      this.$emit("xer-click-header", this.isOpen);
    },
  },
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "xer-accordion--header",
      attrs: { "data-automation-id": _vm.dataAutomationId },
      on: { click: _vm.toggleAccordionItem },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("xer-icon", {
        staticClass: "xer-accordion--header__icon",
        class: _vm.isOpen
          ? "xer-accordion--header__icon-open"
          : "xer-accordion--header__icon-closed",
        attrs: { "xer-name": _vm.isOpen ? "minus-circle" : "plus-circle" },
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//

var script$1 = {
  name: "XerAccordionPanel",
  props: {
    dataAutomationId: {
      type: String,
      default: "accordion-panel",
      required: false,
    },
  },
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "xer-accordion--panel",
      attrs: { "data-automation-id": _vm.dataAutomationId },
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script = {
  name: "XerAccordion",
  components: {
    XerAccordionHeader: __vue_component__$2,
    XerAccordionPanel: __vue_component__$1,
  },
  props: {
    xerAccordionContent: {
      type: Object,
      default: () => {
        return { header: "Header", panelText: "Panel text" };
      },
      validator: (obj) => {
        return !!obj.header && !!obj.panelText;
      },
    },
    dataAutomationId: {
      type: String,
      default: "accordion",
      required: false,
    },
  },
  data() {
    return {
      showContent: false,
    };
  },
  methods: {
    headerClicked(toggleValue) {
      this.showContent = toggleValue;
    },
  },
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "xer-accordion",
      attrs: { "data-automation-id": _vm.dataAutomationId },
    },
    [
      _vm._t("default", function () {
        return [
          _c(
            "xer-accordion-header",
            { on: { "xer-click-header": _vm.headerClicked } },
            [
              _vm._t("xer-accordion-header", function () {
                return [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.xerAccordionContent.header) +
                      "\n      "
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "xer-accordion-fade-slide", mode: "out-in" } },
            [
              _c(
                "xer-accordion-panel",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showContent,
                      expression: "showContent",
                    },
                  ],
                },
                [
                  _vm._t("xer-accordion-panel", function () {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.xerAccordionContent.panelText) +
                          "\n        "
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

require("axios");

const setAxios = (customAxios) => {
};

exports.XerAccordion = __vue_component__;
exports.XerAccordionHeader = __vue_component__$2;
exports.XerAccordionPanel = __vue_component__$1;
exports.XerAlert = __vue_component__$o;
exports.XerAlertStack = __vue_component__$n;
exports.XerApplicationShell = __vue_component__$4;
exports.XerAutocomplete = __vue_component__$l;
exports.XerBreadcrumb = __vue_component__$5;
exports.XerBreadcrumbItem = __vue_component__$6;
exports.XerBreadcrumbLink = __vue_component__$7;
exports.XerButton = __vue_component__$H;
exports.XerButtonGroup = __vue_component__$i;
exports.XerDatepicker = __vue_component__$8;
exports.XerDemoDoughnutChart = __vue_component__$9;
exports.XerDemoTable = __vue_component__$b;
exports.XerDivider = __vue_component__$E;
exports.XerDoughnutChart = __vue_component__$a;
exports.XerDropdown = __vue_component__$m;
exports.XerEllipsis = __vue_component__$s;
exports.XerFileUpload = __vue_component__$r;
exports.XerHeader = __vue_component__$z;
exports.XerHeaderNavLink = __vue_component__$y;
exports.XerIcon = __vue_component__$J;
exports.XerLink = __vue_component__$I;
exports.XerModal = __vue_component__$F;
exports.XerNavbar = __vue_component__$D;
exports.XerNavbarItem = __vue_component__$C;
exports.XerOptionInput = __vue_component__$u;
exports.XerOptionInputList = __vue_component__$t;
exports.XerPagination = __vue_component__$h;
exports.XerPopover = __vue_component__$d;
exports.XerSideSheet = __vue_component__$B;
exports.XerSlider = __vue_component__$k;
exports.XerStepIndicator = __vue_component__$G;
exports.XerTable = __vue_component__$g;
exports.XerTableCell = __vue_component__$f;
exports.XerTableHeader = __vue_component__$e;
exports.XerTabs = __vue_component__$j;
exports.XerTextarea = __vue_component__$p;
exports.XerTextfield = __vue_component__$w;
exports.XerTextfieldOption = __vue_component__$v;
exports.XerToggleSwitch = __vue_component__$3;
exports.XerVueFilePondDemo = __vue_component__$q;
exports.chartHelper = chartHelper;
exports.fileUploadUtils = index;
exports.setAxios = setAxios;
